import React, { useState, useEffect } from "react";
import { format, differenceInDays } from "date-fns";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import queryString from "query-string";
import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import faker from "faker";
import _ from "lodash";
import { saveAs } from "file-saver";
import CSVReader from "react-csv-reader";
import { SubmitLocalStorageSearch } from "../../function";
import numeral from "numeral";
import {
  pdf,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import font from "../../styles/Sarabun-Regular.ttf";
import fontBold from "../../styles/Sarabun-Bold.ttf";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EmitterStatus } from "../../event";
import Swal from "sweetalert2";
import ReactExport from "react-data-export";
import { checkRole } from "../../utils/role";
import fontCodia from "../../styles/CORDIA.ttf";
import fontBoldCodia from "../../styles/Cordia New Bold.ttf";
import { getCheckCurrentDate, getTotalAmount } from "utils/calculator";
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  DataTableCell,
} from "@david.kucsai/react-pdf-table";
import PDFMerger from "pdf-merger-js/browser";
import PDFViewer from "mgr-pdf-viewer-react";
import GenFinalPdf from "./GenFinalPdf";

// Lotte
import Lottie from "react-lottie";
import Loading from "../../animation/loading.json";

// REDUX
import { onChangeSearchBar } from "../../_redux/searchBarSlice";

// HOOKS
import useGetLoan from "../../hooks/useGetLoan";
import useGetLoanCount from "../../hooks/useGetLoanCount";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";
import LoadingPage from "../Loading/LoadingPage";
import LoanTable from "./LoanTable";
import PrevPage from "../../components/Pagination/PrevPage";
import NumberPage from "../../components/Pagination/NumberPage";
import NextPage from "../../components/Pagination/NextPage";
import SelectRows from "../../components/Pagination/SelectRows";
import DataEmpty from "../DataEmpty";

// UTILS
import {
  getCurrentLocalDateTime,
  months,
  pad,
} from "../../utils/getLocalDateTime";

// AWS
import { API, Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";
import { getDetailSegment } from "utils/buro";
import { PdfBuroLetter } from "components/PdfViewer/PdfViewerMain";
import { th } from "date-fns/locale";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Minizip = require("minizip-asm.js");

AWS.config.update({
  region: "ap-southeast-1",
});

const optionsPackage = [
  {
    label: "All Package",
    value: "All",
  },
  {
    label: "อุปโภค / บริโภค",
    value: "อุปโภค / บริโภค",
  },
  {
    label: "ท่องเที่ยว",
    value: "ท่องเที่ยว",
  },
  {
    label: "ธุรกิจ",
    value: "ธุรกิจ",
  },
];

const optionsStatus = [
  {
    label: "All Status",
    value: "All",
  },
  {
    label: "ACTIVE",
    value: "ACTIVE",
  },
  {
    label: "DONE",
    value: "DONE",
  },
  {
    label: "LATE",
    value: "LATE",
  },
  {
    label: "PENDING",
    value: "PENDING",
  },
  {
    label: "REFINANCE",
    value: "REFINANCE",
  },
  {
    label: "FAIL",
    value: "FAIL",
  },
];

const optionsEmail = [
  {
    label: "ทั้งหมด",
    value: "All",
  },
  {
    label: "ส่งอีเมล",
    value: "1",
  },
  {
    label: "ส่งจดหมาย",
    value: "2",
  },
];

const optionsLimit = [
  {
    label: 50,
    value: 50,
  },
  { label: 100, value: 100 },
  { label: 150, value: 150 },
  { label: 200, value: 200 },
  { label: 250, value: 250 },
  { label: 300, value: 300 },
  // { label: 350, value: 350 },
  // { label: 400, value: 400 },
  // { label: 450, value: 450 },
  // { label: 500, value: 500 },
  // { label: 1000, value: 1000 },
];

const optionsReserve = [
  {
    label: "ทั้งหมด",
    value: "ALL",
  },
  { label: "จอง (แสดงเฉพาะของตัวเอง)", value: "RESERVE" },
  { label: "ยังไม่ได้จอง", value: "NOT_RESERVE" },
];

const stylesBuro = StyleSheet.create({
  page: {
    fontFamily: "Sarabun",
    padding: 26,
    fontSize: 12,
    backgroundColor: "#fff",
  },
  bold: {
    fontFamily: "Sarabun",
    fontWeight: "bold",
  },
  date: {
    textAlign: "right",
  },
  newLine: {
    marginTop: 32,
  },
  marginLeft: {
    marginLeft: 20,
  },
  betweenLine: {
    marginTop: 4,
  },
  header: {
    fontSize: 11,
    textAlign: "center",
  },
  red: {
    color: "red",
  },
  end: {
    textAlign: "right",
    marginRight: 32,
  },
  signature: {
    textAlign: "right",
    marginRight: 16,
    fontWeight: "bold",
  },
});

export const stylesInstallment = StyleSheet.create({
  page: {
    fontFamily: "Cordia New",
    padding: 10,
    fontSize: 14,
    backgroundColor: "#fff",
  },
  flex: {
    display: "flex",
  },
  viewHeader: {
    marginTop: "16px",
    paddingLeft: "52px",
    paddingRight: "52px",
  },
  textHeader: {
    textAlign: "center",
    fontSize: 18,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  bold: {
    fontSize: 10,
    fontWeight: 500,
  },
  spaceX: {
    marginLeft: "18px",
    marginRight: "18px",
  },
  text: {
    fontSize: 12,
  },
  section: {
    marginTop: "36px",
    marginLeft: "42px",
  },
  space: {
    margin: "2px",
  },
  installment: {
    display: "flex",
    marginTop: "16px",
  },
});

Font.register({
  family: "Cordia New",
  fonts: [{ src: fontCodia }, { src: fontBoldCodia }],
});

// Font.register({
//   family: "Cordia New",
//   fonts: [{ src: font }, { src: fontBold }],
// });

var isProcessing = false;

const stylesEnvelop = StyleSheet.create({
  page: {
    fontFamily: "Cordia New",
    padding: 10,
    fontSize: 14,
    backgroundColor: "#fff",
  },
  header: {
    textAlign: "right",
    marginRight: "3px",
    marginTop: "2px",
  },
  section: {
    marginTop: "36px",
    marginLeft: "42px",
  },
  space: {
    margin: "3px",
  },
});

export const getThaiMonth = (rawMonth) => {
  var currentMonth = "มกราคม";
  if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
  if (rawMonth == "03") currentMonth = "มีนาคม";
  if (rawMonth == "04") currentMonth = "เมษายน";
  if (rawMonth == "05") currentMonth = "พฤษภาคม";
  if (rawMonth == "06") currentMonth = "มิถุนายน";
  if (rawMonth == "07") currentMonth = "กรกฎาคม";
  if (rawMonth == "08") currentMonth = "สิงหาคม";
  if (rawMonth == "09") currentMonth = "กันยายน";
  if (rawMonth == "10") currentMonth = "ตุลาคม";
  if (rawMonth == "11") currentMonth = "พฤศจิกายน";
  if (rawMonth == "12") currentMonth = "ธันวาคม";
  return currentMonth;
};

export const PdfBuro = ({ data, letter_id, index }) => {
  var now_th = moment.locale("th");
  var today = moment().add(543, "year").format("DD/MM/YYYY");
  var currentYear = moment().add(543, "year").year();
  var rawMonth = moment().format("MM");
  var currentMonth = getThaiMonth(rawMonth);
  var previousRawMonth = moment().add(-1, "month").format("MM");
  var previousYear = moment().add(543).add(-1, "month").year();
  var previousMonth = getThaiMonth(previousRawMonth);
  // var previousYear = Number(currentYear) - 1;
  var header = "หนังสือแจ้งครั้งแรกฉบับที่";

  return (
    <Page size="A4" style={stylesBuro.page}>
      <Text style={stylesBuro.header}>
        หนังสือแจ้งให้ลูกค้าทราบเกี่ยวกับการส่งข้อมูลให้แก่บริษัทข้อมูลเครดิต (
        {header}{" "}
        {(new Date().getFullYear() + 543).toString() +
          "/" +
          getCountString(+letter_id + index + 1)}
        )
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <View style={stylesBuro.betweenLine}></View>
      <Text style={stylesBuro.date}>วันที่ {today}</Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        เรียน คุณ {data?.name} {data?.lastname}{" "}
      </Text>
      <View style={stylesBuro.newLine}></View>
      <Text style={stylesBuro.marginLeft}>
        ตามพระราชบัญญัติการประกอบธุรกิจข้อมูลเครดิต พ.ศ. 2545
        และที่แก้ไขเพิ่มเติม และประกาศคณะกรรมการ
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        คุ้มครองข้อมูลเครดิต กำหนดไว้{" "}
        <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
        มีหน้าที่ต้องส่งข้อมูลเครดิตของท่านให้แก่ บริษัท
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        ข้อมูลเครดิตแห่งชาติ จำกัด ที่{" "}
        <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
        เป็นสมาชิกอยู่ และแจ้งให้ท่านทราบเกี่ยวกับข้อมูล
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        เครดิตที่ส่งไป ดังกล่าว ดังนั้น
        เพื่อดำเนินการให้เป็นไปตามบทบัญญัติของพระราชบัญญัติ ตลอดจนประกาศคณะ{" "}
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <View>
        <Text>
          กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด </Text>
          จึงขอแจ้งให้ท่านทราบว่า ใน{" "}
          <Text style={stylesBuro.bold}>เดือน {currentMonth}</Text>
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          <Text style={stylesBuro.bold}>
            ปี {currentYear} บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
          </Text>{" "}
          ได้ส่งข้อมูลเครดิตของท่าน ณ{" "}
          <Text style={stylesBuro.bold}>
            เดือน {previousMonth} ปี {previousYear + 543}
          </Text>{" "}
          ให้แก่ บริษัท
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          ข้อมูลเครดิตแห่งชาติ จำกัด แล้ว โดยข้อมูลเครดิตที่{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>
          ส่งไปดังกล่าว มีรายละเอียด
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text> ส่งไปดังกล่าว มีรายละเอียด ปรากฏท้ายหนังสือนี้ </Text>
      </View>

      <View style={stylesBuro.betweenLine}></View>
      <View style={stylesBuro.betweenLine}></View>
      <View style={stylesBuro.betweenLine}></View>
      <View style={stylesBuro.betweenLine}></View>
      <View style={stylesBuro.betweenLine}></View>
      <Text style={stylesBuro.marginLeft}>
        {" "}
        ทั้งนี้ ข้อมูลเครดิตที่{" "}
        <Text style={stylesBuro.bold}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>{" "}
        นำส่งให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        ดังกล่าว{" "}
        <Text style={stylesBuro.red}>แสดงรายละเอียดการชำระสินเชื่อ</Text>{" "}
        ที่ท่านมีกับ{" "}
        <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
        เพียงสถานะล่าสุดในขณะที่{" "}
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
        จัดทำข้อมูลเพื่อนำส่งข้อมูลเครดิตให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ
        จำกัด{" "}
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        ดังกล่าวเท่านั้น ซึ่งข้อมูลเครดิตดังกล่าวอาจแตกต่างจากข้อมูลที่{" "}
        <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
        มีอยู่ในขณะนี้
      </Text>
      <View style={stylesBuro.newLine}></View>

      <Text style={stylesBuro.marginLeft}>
        จึงเรียนมาเพื่อโปรดทราบ หากท่านมีข้อสงสัย หรือข้อสอบถาม โปรด
      </Text>
      <View style={stylesBuro.betweenLine}></View>
      <Text>
        ติดต่อ{" "}
        <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
        โทรศัพท์ 02-821-6710
      </Text>
      <View style={stylesBuro.newLine}></View>
      <Text style={stylesBuro.end}>ขอแสดงความนับถือ</Text>
      <View style={stylesBuro.betweenLine}></View>
      <View style={stylesBuro.betweenLine}></View>
      <Text style={stylesBuro.signature}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>
    </Page>
  );
};

export const PdfInstallment = ({ data }) => {
  return (
    <Page style={stylesInstallment.page}>
      <View style={stylesInstallment.viewHeader}>
        <Text style={stylesInstallment.textHeader}>รายละเอียดการผ่อนชำระ </Text>
        <View style={stylesInstallment.space}></View>
        <Text>
          <Text style={stylesInstallment.bold}>ชื่อผู้ทำสัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {data.article + " " + data.fullname}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.bold}>รหัสบัตรประชาชน</Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.text}>{data.citizenid}</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>เลขที่สัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>{data.loan_kbank_id}</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>วงเงินสินเชื่อ</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {numeral(data.requestamount).format("0,000")}
          </Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.bold}>อัตราดอกเบี้ย</Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.text}>{data.interest_rate}%</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>ระยะเวลาผ่อนชำระ </Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>{data.period} งวด</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>วันที่เริ่มต้นสัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {format(new Date(data.requestTime), "dd/MM/yyyy")}
          </Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.bold}>วันที่สิ้นสุดสัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {format(new Date(data.endDate), "dd/MM/yyyy")}
          </Text>
        </Text>
      </View>
      <View style={stylesInstallment.installment}>
        <Table
          style={{ borderColor: "#aaa" }}
          data={data.installments.map((installment, index) => {
            return { ...installment, period: index + 1 };
          })}
        >
          <TableHeader textAlign={"center"}>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                color: "#444",
                fontWeight: "bold",
                backgroundColor: "#ddd",
              }}
            >
              งวดที่
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                color: "#444",
                fontWeight: "bold",
                backgroundColor: "#ddd",
              }}
            >
              เงินต้น
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                color: "#444",
                fontWeight: "bold",
                backgroundColor: "#ddd",
              }}
            >
              ดอกเบี้ย
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                padding: 4,
                fontSize: 8,
                backgroundColor: "#ddd",
              }}
            >
              รวมค่างวด
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                color: "#444",
                fontWeight: "bold",
                backgroundColor: "#ddd",
              }}
            >
              เงินต้นคงเหลือ
            </TableCell>
            <TableCell
              style={{
                fontWeight: "bold",
                padding: 4,
                fontSize: 8,
                backgroundColor: "#ddd",
              }}
            >
              วันครบกำหนดชำระ&nbsp;&nbsp;
            </TableCell>
          </TableHeader>
          <TableBody height="100%" textAlign={"center"}>
            <DataTableCell getContent={(r) => r.period} />
            <DataTableCell
              getContent={(r) => numeral(r.actualPrinciple).format("0,000")}
            />
            <DataTableCell getContent={(r) => r.actualInterest} />
            <DataTableCell
              getContent={(r) =>
                numeral(
                  r.actualPrinciple + r.actualInterest + r.interestMore
                ).format("0,000")
              }
            />
            <DataTableCell
              getContent={(r) => numeral(r.planCapitalRemain).format("0,000")}
            />
            <DataTableCell
              getContent={(r) => format(new Date(r.date), "dd-MM-yyyy")}
            />
          </TableBody>
        </Table>
      </View>
    </Page>
  );
};

export const PdfInstallment2 = ({ data }) => {
  const today = getCurrentLocalDateTime().fullDate;

  const getFirstPenalty = () => {
    const firstPenalty = data.installments.find((installment) => {
      return (
        installment.date < today &&
        installment.actualPrinciple + installment.actualInterest > 0
      );
    });
    return firstPenalty;
  };

  return (
    <Page
      orientation="landscape"
      style={{
        ...stylesInstallment.page,
        paddingLeft: 15,
        paddingRight: 15,
        fontFamily: "Sarabun",
        // transform: "translateX(-120%) rotate(90deg)",
      }}
    >
      <View style={stylesInstallment.viewHeader}>
        <Text style={stylesInstallment.textHeader}>รายละเอียดการผ่อนชำระ </Text>
        <View style={stylesInstallment.space}></View>
        <Text>
          <Text style={stylesInstallment.bold}>ชื่อผู้ทำสัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {data.article + " " + data.fullname}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.bold}>รหัสบัตรประชาชน</Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.text}>{data.citizenid}</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>เลขที่สัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>{data.loan_kbank_id}</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>วงเงินสินเชื่อ</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {numeral(data.requestamount).format("0,000")}
          </Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.bold}>อัตราดอกเบี้ย</Text>
          <Text style={stylesInstallment.spaceX}> </Text>
          <Text style={stylesInstallment.text}>{data.interest_rate}%</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>ระยะเวลาผ่อนชำระ </Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>{data.period} งวด</Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>วันที่เริ่มต้นสัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {format(new Date(data.requestTime), "dd/MM/yyyy")}
          </Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>วันที่สิ้นสุดสัญญา</Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {format(new Date(data.endDate), "dd/MM/yyyy")}
          </Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>
            {" "}
            ข้อมูล ณ วันที่&nbsp;&nbsp;
          </Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {format(
              new Date(data?.installments[data?.installments.length - 1].date),
              "dd/MM/yyyy",
              {
                locale: th,
              }
            )}
          </Text>
        </Text>
        <Text>
          <Text style={stylesInstallment.bold}>
            {" "}
            ผิดนัดงวดแรกวันที่ &nbsp;&nbsp;
          </Text>
          <View style={stylesInstallment.spaceX}> </View>
          <Text style={stylesInstallment.text}>
            {!getFirstPenalty()
              ? "-"
              : format(
                  new Date(getFirstPenalty()?.date).setDate(
                    new Date(getFirstPenalty()?.date).getDate() + 1
                  ),
                  "dd/MM/yyyy"
                )}
          </Text>
        </Text>
      </View>
      <View
        style={{
          ...stylesInstallment.installment,
          paddingLeft: 20,
          paddingRight: 20,
        }}
      >
        <Table
          style={{ borderColor: "#aaa" }}
          data={data.installments
            .concat([
              {
                ...data.installments[0],
                period: "รวม",
                actualPrinciple: data.installments.reduce(
                  (a, b) => a + b.actualPrinciple,
                  0
                ),
                actualInterest: data.installments.reduce(
                  (a, b) => a + b.actualInterest,
                  0
                ),
              },
            ])
            .map((installment, index) => {
              const currentDateIndex = getCheckCurrentDate(data?.installments);
              const checkCurrentDateIndex = currentDateIndex === index;
              return {
                ...installment,
                period: installment.period === "รวม" ? "รวม" : index + 1,
                checkCurrentDateIndex,
                index,
              };
            })}
        >
          <TableHeader textAlign={"center"}>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              งวดที่&nbsp;
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>เงินต้น</Text>
              <Text>คงเหลือ&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 8,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              งวดประจำวันที่&nbsp;
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>เงินต้น</Text>
              <Text>ประจำงวด&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>ดอกเบี้ย</Text>
              <Text>ประจำงวด&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>รวม</Text>
              <Text>ค่างวด&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 8,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              วันที่ชำระ&nbsp;
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>เงินต้น&nbsp;</Text>
              <Text>(ชำระ)&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>ดอกเบี้ย&nbsp;</Text>
              <Text>(ชำระ)&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              <Text>ทั้งหมด&nbsp;</Text>
              <Text>(ชำระ)&nbsp;</Text>
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              เงินต้น (ค้างชำระ)&nbsp;
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              ดอกเบี้ย (ค้างชำระ)&nbsp;
            </TableCell>
            <TableCell
              style={{
                fontSize: 8,
                padding: 4,
                fontWeight: "bold",
                backgroundColor: "#ddd",
                textAlign: "center",
              }}
            >
              ทั้งหมด (ค้างชำระ)&nbsp;
            </TableCell>
          </TableHeader>
          <TableBody height="100%" textAlign={"center"}>
            <DataTableCell
              style={{
                fontSize: 10,
                // paddingRight: 1
              }}
              getContent={(r) => {
                let check = r.date <= today;
                return (
                  <Text style={{ fontWeight: check ? "bold" : "normal" }}>
                    {r.period === "รวม" ? "" : r.period}
                  </Text>
                );
              }}
              // getContent={(r) => (r.period === "รวม" ? "" : r.period)}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {r.period === "รวม"
                      ? ""
                      : numeral(r.planCapitalRemain).format("0,000")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                paddingLeft: 4,
                paddingRight: 4,
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {r.period === "รวม"
                      ? ""
                      : format(new Date(r.date), "dd-MM-yyyy")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              // style={{
              //   paddingLeft: 4,
              //   paddingRight: 4,
              // }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {r.period === "รวม" ? "" : r.planPrinciple}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              // style={{
              //   paddingLeft: 4,
              //   paddingRight: 3,
              // }}
              getContent={(r) => (
                <Text
                  style={{
                    fontWeight: r.date <= today ? "bold" : "normal",
                  }}
                >
                  {r.period === "รวม" ? "" : r.planInterest}
                </Text>
              )}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {r.period === "รวม" ? "" : r.planPrinciple + r.planInterest}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                paddingLeft: 4,
                paddingRight: 4,
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {r.period === "รวม"
                      ? "รวม"
                      : r.paid_date !== "-"
                      ? format(new Date(r.paid_date), "dd-MM-yyyy")
                      : "-"}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {numeral(
                      data?.evidence?.reduce((prev, curr) => {
                        if (
                          String(curr.period) === String(r.period) ||
                          r.period === "รวม"
                        ) {
                          return prev + curr?.paid_principle;
                        }
                        return prev;
                      }, 0)
                    ).format("0,0")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {numeral(
                      data?.evidence?.reduce((prev, curr) => {
                        if (
                          String(curr.period) === String(r.period) ||
                          r.period === "รวม"
                        ) {
                          return (
                            prev + curr?.paid_interest + curr?.paid_interestMore
                          );
                        }
                        return prev;
                      }, 0)
                    ).format("0,0")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {numeral(
                      data?.evidence?.reduce((prev, curr) => {
                        if (
                          String(curr.period) === String(r.period) ||
                          r.period === "รวม"
                        ) {
                          return (
                            prev +
                            curr?.paid_interest +
                            curr?.paid_interestMore +
                            curr?.paid_principle
                          );
                        }
                        return prev;
                      }, 0)
                    ).format("0,0")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {numeral(r.actualPrinciple).format("0,0")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {numeral(r.actualInterest).format("0,0")}
                  </Text>
                );
              }}
            />
            <DataTableCell
              style={{
                fontSize: 10,
              }}
              getContent={(r) => {
                return (
                  <Text
                    style={{
                      fontWeight: r.date <= today ? "bold" : "normal",
                    }}
                  >
                    {numeral(r.actualPrinciple + r.actualInterest).format(
                      "0,0"
                    )}
                  </Text>
                );
              }}
            />
          </TableBody>
        </Table>

        {/* <Text style={{ marginTop: "10px" }}>
          ยอดเงินที่ชำระทั้งหมด{" "}
          {numeral(
            data?.evidence?.reduce((prev, curr) => {
              return prev + curr?.paid_amount;
            }, 0)
          ).format("0,0")}{" "}
          บาท
        </Text>
        <Text style={{ marginLeft: "5px" }}>
          - คิดเป็นเงินต้น{" "}
          {numeral(
            data?.evidence?.reduce((prev, curr) => {
              return prev + curr?.paid_principle;
            }, 0)
          ).format("0,0")}{" "}
          บาท
        </Text>
        <Text style={{ marginLeft: "5px" }}>
          - คิดเป็นเงินต้น{" "}
          {numeral(
            data?.evidence?.reduce((prev, curr) => {
              return prev + curr?.paid_interest;
            }, 0)
          ).format("0,0")}{" "}
          บาท
        </Text>
        <Text style={{ marginTop: "10px" }}>
          ยอดเงินที่ค้างชำระ&nbsp;&nbsp;
          {numeral(
            data?.installments?.reduce((prev, curr) => {
              if (curr.date <= today) {
                return prev + curr?.actualPrinciple + curr?.actualInterest;
              }
              return prev;
            }, 0)
          ).format("0,0")}{" "}
          บาท
        </Text>
        <Text style={{ marginLeft: "5px" }}>
          - คิดเป็นเงินต้น{" "}
          {numeral(
            data?.installments?.reduce((prev, curr) => {
              if (curr.date <= today) {
                return prev + curr?.actualPrinciple;
              }
              return prev;
            }, 0)
          ).format("0,0")}{" "}
          บาท
        </Text>
        <Text style={{ marginLeft: "5px" }}>
          - คิดเป็นเงินต้น{" "}
          {numeral(
            data?.installments?.reduce((prev, curr) => {
              if (curr.date <= today) {
                return prev + curr?.actualInterest;
              }
              return prev;
            }, 0)
          ).format("0,0")}{" "}
          บาท
        </Text>
        <Text style={{ marginTop: "10px" }}>
          ข้อมูล ณ วันที่{" "}
          {format(new Date(), "dd MMMM yyyy", {
            locale: th,
          })}
        </Text> */}
      </View>
    </Page>
  );
};

export const getCountString = (count) => {
  let newCount = count.toString();
  let prefix = 10 - newCount.length;
  for (let i = 0; i < prefix; i++) newCount = "0" + newCount;
  return newCount;
};

export const PdfDocumentEnvelope = ({ loan = [], isCurrentAddress = true }) => {
  return (
    <Document>
      {loan.map((row, index) => {
        const {
          loan_kbank_id,
          name,
          lastname,
          address,
          addressCode,
          addressDesc,
          officialAddressCode,
          officialAddressDesc,
          currentAddress,
        } = row.original;

        let myAddress = addressCode + " " + addressDesc + " " + address;

        if (isCurrentAddress) {
          myAddress =
            officialAddressCode +
            " " +
            officialAddressDesc +
            " " +
            currentAddress;
        }

        return (
          <Page key={index} size={[288, 216]} style={stylesEnvelop.page}>
            <View style={stylesEnvelop.header}>
              <Text>เลขที่สัญญา {loan_kbank_id}</Text>
            </View>
            <View style={stylesEnvelop.section}>
              <Text>กรุณาส่ง</Text>
              <View style={stylesEnvelop.space}></View>
              <Text>คุณ{`${name} ${lastname}`}</Text>
              <View style={stylesEnvelop.space}></View>
              <Text>ที่อยู่ {`${myAddress}`}</Text>
              {/* <View style={stylesEnvelop.space}></View>
              <Text>{`${address}`}</Text> */}
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

function LoanMain(props) {
  const Limit = 50;
  const dispatch = useDispatch();
  const router = useHistory();
  const search = router.location.search;

  const { user } = useSelector((state) => state.initializeApp);
  const searchBar = useSelector((state) => state.searchBar);

  const today = getCurrentLocalDateTime();
  const nextWeek = new Date();
  const preWeek = new Date();

  nextWeek.setDate(new Date().getDate() + 7);
  // nextWeek.setFullYear(nextWeek.getFullYear() + 10);
  preWeek.setDate(new Date().getDate() - 7);
  const defaultMaxOverdueDate = getCurrentLocalDateTime(
    new Date(+today.year, today.monthIndex, +today.date)
  );
  const defaultMinOverdueDate = getCurrentLocalDateTime(
    new Date(+today.year, today.monthIndex, +today.date)
  );
  const defaultPayDate = today.fullDate;
  const defaultBeginOverdueDate = getCurrentLocalDateTime(preWeek);
  const defaultEndOverdueDate = getCurrentLocalDateTime(nextWeek);

  const querySearch = queryString.parse(search);

  const DEFAULT_QUERY = {
    Limit,
    countData: 1,
    paid_date: defaultPayDate,
    package: optionsPackage[0].value,
    status: optionsStatus[1].value,
    // min_created: defaultBeginOverdueDate.fullDate,
    // max_created: defaultEndOverdueDate.fullDate,
    min_created: "",
    max_created: "",
    overDueDate: today.fullDate,
    letter: "All",
    SELECT_ALL: true,
  };

  const [countObj, setCountObj] = useState({
    All: 0,
    ACTIVE: 0,
    DONE: 0,
    LATE: 0,
    PENDING: 0,
    REFINANCE: 0,
    FAIL: 0,
  });

  const { datas, loading, error, getData, count } = useGetLoan(DEFAULT_QUERY);
  const {
    datas: datasCount,
    loading: loadingCount,
    error: errorCount,
    getData: getDataCount,
    items,
    getLastItem,
  } = useGetLoanCount({ ...DEFAULT_QUERY, setCountObj });

  const [currentType, setCurrentType] = useState("ACTIVE");
  const [searchBy, setSearchBy] = useState("request_id");
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingReserve, setLoadingReserve] = useState(false);
  const [allTime, setAllTime] = useState(true);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState({ value: Limit, label: Limit });
  const [pageType, setPageType] = useState(null);
  const [overDueDate, setOverDueDate] = useState();
  const [loadingImport, setLoadingImport] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingBuroPdf, setLoadingBuroPdf] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [firstLanding, setFirstLanding] = useState(true);
  const [currentDate, setCurrentDate] = useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const [countExport, setCountExport] = useState(0);
  const [dataAll, setDataAll] = useState([]);
  const [loadingExportAll, setLoadingExportAll] = useState(false);
  const [loadingAutoMail, setLoadingAutoMail] = useState(false);
  const [countAuotMail, setCountAutoMail] = useState(0);
  const [passwordSyncDelete, setPasswordSyncDelete] = useState();
  const [checkPassword, setCheckPassword] = useState(false);

  const [query, setQuery] = useState(DEFAULT_QUERY);

  useEffect(() => {
    setCountExport(countObj[currentType]);
  }, [datasCount]);

  if (loading)
    return (
      <ContainerContent>
        <LoadingPage />
      </ContainerContent>
    );
  if (error) return <p className="text-black">Error</p>;

  const onSelectReservie = (e) => {
    const { value } = e;

    let reserveBy = "";

    if (value === "RESERVE") {
      reserveBy = user.username;
    } else if (value === "NOT_RESERVE") {
      reserveBy = "NOT_RESERVE";
    }

    setQuery((prev) => {
      return {
        ...prev,
        reserve: value,
        reserveBy,
      };
    });
  };

  const onSelect = (name) => (e) => {
    const { value } = e;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onField = (e) => {
    const { name, value } = e.target;
    setQuery((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onChangeAllTime = (e) => {
    setAllTime(e.target.checked);
    if (e.target.checked) {
      setQuery((prev) => {
        return {
          ...prev,
          min_created: defaultBeginOverdueDate.fullDate,
          max_created: defaultEndOverdueDate.fullDate,
        };
      });
    }
  };

  const onReserve = (status) => async (e) => {
    try {
      setLoadingReserve(true);
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            for (const row of selectedRows) {
              const { original } = row;
              await API.put(
                "MoneyHubAdmin",
                `/loan/reserve/${original.loan_id}`,
                {
                  body: {
                    reserveBy: status === "reserve" ? user.username : "",
                  },
                  headers: {
                    Authorization: `Bearer ${(await Auth.currentSession())
                      .getIdToken()
                      .getJwtToken()}`,
                  },
                }
              );
            }
          } catch (error) {
            await EmitterStatus("ERROR", { logMessage: error });
          }
        },
      });
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await getData(query);
    } catch (error) {
      await EmitterStatus("ERROR", { logMessage: error });
    } finally {
      setLoadingReserve(false);
    }
  };

  const onClickGetLoan = async () => {
    const ranRequestAmountList = [
      5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000, 30000, 50000,
    ];
    const ranPeriodList = [3, 6, 12];
    const ranPurposeList = ["ธุรกิจ", "อุปโภค / บริโภค", "ท่องเที่ยว"];

    const ranRequestAmountIndex = Math.floor(
      Math.random() * ranRequestAmountList.length
    );
    const ranPeriodIndex = Math.floor(Math.random() * ranPeriodList.length);
    const ranPurposeIndex = Math.floor(Math.random() * ranPurposeList.length);

    const phone_number = "0819278409";
    const executeTime = getCurrentLocalDateTime(new Date(currentDate)).date;

    // const name = faker.name.firstName();
    // const lastname = faker.name.lastName();
    const name = faker.name.firstName();
    const lastname = faker.name.lastName();
    const data = [
      {
        name: "พนิต",
        lastname: "จ๋วงพานิช",
        citizenid: "4557769844752",
        birthdateTh: "01/06/2533",
        currentAddress: "929,คลองจั่น,บางกะปิ,กรุงเทพมหานคร,10240",
        period: 12,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        request_id: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        toDayTestGenLoan: "2020-07-15",
      },
      {
        name: "ปนัดดา",
        lastname: "อยู่ดี",
        citizenid: "3365466155871",
        birthdateTh: "05/02/2534",
        currentAddress: "429,หัวหมาก,บางกะปิ,กรุงเทพมหานคร,10250",
        period: 3,
        requestamount: 15000,
        payPerMonth: 15000,
        completedAt: "09",
        request_id: getCurrentLocalDateTime(new Date("2021-04-09")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-09")).isoDateTime,
        toDayTestGenLoan: "2021-04-09",
      },
      {
        name: "สมชาย",
        lastname: "เปลี่ยนสี",
        citizenid: "3051499825492",
        birthdateTh: "07/04/2513",
        currentAddress: "14,ท่าข้าม,บางขุนเทียน,กรุงเทพมหานคร,10150",
        period: 6,
        requestamount: 18000,
        payPerMonth: 18000,
        completedAt: "12",
        request_id: getCurrentLocalDateTime(new Date("2021-02-12")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-02-12")).isoDateTime,
        toDayTestGenLoan: "2021-02-12",
      },
      {
        name: "ไกรศร", //ข้ามปีผิด
        lastname: "อันโอชา",
        citizenid: "9042595648601",
        birthdateTh: "08/01/2508",
        currentAddress: "54,ศรีดงเย็น,ไชยปราการ,เชียงใหม่,50320",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "01",
        request_id: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        toDayTestGenLoan: "2020-12-01",
      },
      {
        name: "ยง",
        lastname: "ไกรบุตร",
        citizenid: "9187168852291",
        birthdateTh: "25/12/2527",
        currentAddress: "131,ฉลุง,หาดใหญ่,สงขลา,90110",
        period: 6,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "13",
        request_id: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        toDayTestGenLoan: "2021-01-13",
      },
      {
        name: "ธีระ",
        lastname: "มั่งมี",
        citizenid: "8072666106271",
        birthdateTh: "16/08/2540",
        currentAddress: "15,หนองโก,กระนวน,ขอนแก่น,40170",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "12",
        request_id: getCurrentLocalDateTime(new Date("2020-12-12")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-12")).isoDateTime,
        toDayTestGenLoan: "2020-12-12",
      },
      {
        name: "พิชาญ",
        lastname: "บัวบาง",
        citizenid: "1383925076366",
        birthdateTh: "23/03/2530",
        currentAddress: "97,เมือง,เมือง,เลย,42000",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "15",
        request_id: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-07-15")).isoDateTime,
        toDayTestGenLoan: "2020-07-15",
      },
      {
        name: "ชัยพร",
        lastname: "คุ้มเพชร",
        citizenid: "9549604855203",
        birthdateTh: "17/04/2543",
        currentAddress: "66,แม่ใจ,แม่ใจ,พะเยา,56130",
        period: 3,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        request_id: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        toDayTestGenLoan: "2021-03-15",
      },
      {
        name: "ประเวศ",
        lastname: "ชั่งทอง",
        citizenid: "9953255318250",
        birthdateTh: "11/03/2541",
        currentAddress: "11,แม่ยม,เมืองแพร่,แพร่,54000",
        period: 6,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "พรชัย",
        lastname: "โปร่งพรมมา",
        citizenid: "6035143401509",
        birthdateTh: "15/04/2538",
        currentAddress: "74,แม่สา,เวียงสา,น่าน,55110",
        period: 12,
        requestamount: 16000,
        payPerMonth: 16000,
        completedAt: "05",
        request_id: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-05")).isoDateTime,
        toDayTestGenLoan: "2021-01-05",
      },
      {
        name: "อรอนง",
        lastname: "แก้วสว่าง",
        citizenid: "2258093945584",
        birthdateTh: "09/06/2534",
        currentAddress: "114,บางบำหรุ,บางพลัด,กรุงเทพมหานคร,10700",
        period: 3,
        requestamount: 15000,
        payPerMonth: 15000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "สมพง",
        lastname: "รอดกสิกรรม",
        citizenid: "5889449024824",
        birthdateTh: "30/04/2538",
        currentAddress: "99,บางกรวย,บางกรวย,นนทบุรี,11130",
        period: 3,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        toDayTestGenLoan: "2021-05-10",
      },
      {
        name: "อาคม",
        lastname: "สุทธิ",
        citizenid: "7795906360876",
        birthdateTh: "07/08/2540",
        currentAddress: "88,รังสิต,ธัญบุรี,ปทุมธานี12110",
        period: 3,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        toDayTestGenLoan: "2021-03-10",
      },
      {
        name: "อานน",
        lastname: "มีสุข",
        citizenid: "5724088677310",
        birthdateTh: "03/03/2536",
        currentAddress: "63,สามแยก,เลิกนกทา,ยโสธร,35120",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2020-12-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-10")).isoDateTime,
        toDayTestGenLoan: "2020-12-10",
      },
      {
        name: "ทศ",
        lastname: "พรมมา",
        citizenid: "3671764290592",
        birthdateTh: "23/06/2519",
        currentAddress: "67,อ่างศิลา,เมืองชลบุรี,ชลบุรี,20000",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2020-06-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-06-10")).isoDateTime,
        toDayTestGenLoan: "2020-06-10",
      },
      {
        name: "สมปอง",
        lastname: "มณีโชติ",
        citizenid: "7723005934781",
        birthdateTh: "12/04/2523",
        currentAddress: "77,ห้วยแร้ง,เมืองตราด,ตราด,23000",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "ปรเมศ",
        lastname: "แก้วเพชร",
        citizenid: "6458528626917",
        birthdateTh: "23/09/2532",
        currentAddress: "78,น้ำผุด,เมืองตรัง,ตรัง,92000",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2020-10-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-10-10")).isoDateTime,
        toDayTestGenLoan: "2020-10-10",
      },
      {
        name: "อวยชัย",
        lastname: "จำปาทอง",
        citizenid: "3653492374912",
        birthdateTh: "24/04/2519",
        currentAddress: "87,เกะรอ,รามัน,ยะลา,95140",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-10")).isoDateTime,
        toDayTestGenLoan: "2021-04-10",
      },
      {
        name: "พรเทพ",
        lastname: "จันทร์มี",
        citizenid: "5866611438037",
        birthdateTh: "08/11/2539",
        currentAddress: "64,ตลุก,สรรพยา,ชัยนาท,17150",
        period: 3,
        requestamount: 24000,
        payPerMonth: 24000,
        completedAt: "10",
        request_id: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-10")).isoDateTime,
        toDayTestGenLoan: "2021-03-10",
      },
      {
        name: "ดอน",
        lastname: "ชูนำชัย",
        citizenid: "8417404116416",
        birthdateTh: "31/07/2542",
        currentAddress: "33,หลักฟ้า,ไชโย,อ่างทอง,14140",
        period: 6,
        requestamount: 18000,
        payPerMonth: 18000,
        completedAt: "02",
        request_id: getCurrentLocalDateTime(new Date("2021-04-02")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-02")).isoDateTime,
        toDayTestGenLoan: "2021-04-02",
      },
    ];

    const data2 = [
      {
        name: "เทสเท่านั้น",
        lastname: "เทสเท่านั้น",
        citizenid: "1002404711219",
        birthdateTh: "01/06/2533",
        currentAddress: "เทส",
        period: 12,
        requestamount: 24000,
        payPerMonth: 24000,
        completedAt: "26",
        phone_number: "0877908161",
        bankNo: "7302824813",
        request_id: getCurrentLocalDateTime(new Date("2021-08-26")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-08-26")).isoDateTime,
        toDayTestGenLoan: "2021-08-26",
      },
      // {
      //   name: "ชยุตม์",
      //   lastname: "ปิยะวงศ์ไพบูลย์",
      //   citizenid: "1100800862918",
      //   birthdateTh: "01/06/2534",
      //   currentAddress:
      //     "511/854 ถ.จรัญสนิทวงศ์ แขวงบางขุนศรี เขตบางกอกน้อย จ.กรุงเทพฯ 10700",
      //   period: 6,
      //   requestamount: 18000,
      //   payPerMonth: 18000,
      //   completedAt: "2",
      //   phone_number: "0867761082",
      //   bankNo: "0863966698",
      //   request_id: getCurrentLocalDateTime(new Date("2021-08-10")).isoDateTime,
      //   dueTime: getCurrentLocalDateTime(new Date("2021-08-10")).isoDateTime,
      //   toDayTestGenLoan: "2021-08-10",
      // },
      {
        name: "ทรรศนีย์",
        lastname: "ริยาพันธ์",
        citizenid: "1800500038083",
        birthdateTh: "01/06/2538",
        currentAddress: "75 หมู่ที่ 4 ต.กะทูน อ.พิปูน จ.นครศรีธรรมราช 80270",
        period: 6,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "2",
        phone_number: "0856842510",
        bankNo: "0033480903",
        request_id: getCurrentLocalDateTime(new Date("2021-08-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-08-10")).isoDateTime,
        toDayTestGenLoan: "2021-08-10",
      },
      {
        name: "สมิตรา",
        lastname: "แก้วคำ",
        citizenid: "1240800149340",
        birthdateTh: "01/06/2530",
        currentAddress:
          "179 หมู่ที่ 5 ต.เมืองเสือ อ.พยัคฆภูมิพิสัย จ.มหาสารคาม 44110",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "1",
        phone_number: "0639685368",
        bankNo: "0313707288",
        request_id: getCurrentLocalDateTime(new Date("2020-08-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-08-10")).isoDateTime,
        toDayTestGenLoan: "2021-08-10",
      },
      {
        name: "รัตนาพร",
        lastname: "นันทะพันธ์",
        citizenid: "1639900348446",
        birthdateTh: "01/06/2528",
        currentAddress: "9 หมู่9 ต.นาโบสถ์ อ.วังเจ้า จ.ตาก 63000",
        period: 12,
        requestamount: 10000,
        payPerMonth: 10000,
        completedAt: "1",
        phone_number: "0985592973",
        bankNo: "0691754863",
        request_id: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-01")).isoDateTime,
        toDayTestGenLoan: "2020-12-01",
      },
      {
        name: "ชัยกฤติ์พงษ์",
        lastname: "สุขพันธ์",
        citizenid: "1709900497360",
        birthdateTh: "01/06/2536",
        currentAddress:
          "399 หมู่ 3 ตำบลวังจันทร์ อำเภอแก่งกระจาน จ.เพชรบุรี 76170",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        phone_number: "0649461989",
        bankNo: "0251122032",
        request_id: getCurrentLocalDateTime(new Date("2021-08-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-08-10")).isoDateTime,
        toDayTestGenLoan: "2021-08-10",
      },
      {
        name: "สุนิสา",
        lastname: "พานเที่ยง",
        citizenid: "1149900495541",
        birthdateTh: "01/06/2537",
        currentAddress:
          "9/2 หมู่ที่ 4 ต.สิงหนาท  อ.ลาดบัวหลวง จ.พระนครศรีอยุธยา 13230",
        period: 6,
        requestamount: 30000,
        payPerMonth: 30000,
        completedAt: "13",
        phone_number: "0884602766",
        bankNo: "1340366428",
        request_id: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-13")).isoDateTime,
        toDayTestGenLoan: "2021-01-13",
      },
      {
        name: "ภูวเดช",
        lastname: "รักรุ่งเรือง",
        citizenid: "1103000048143",
        birthdateTh: "01/06/2532",
        currentAddress:
          "100/261 หมู่ 4 แขวงคลองสองต้นนุ่น เขตลาดกระบัง จ.กรุงเทพฯ 10520",
        period: 6,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "10",
        phone_number: "0846505167",
        bankNo: "0882608684",
        request_id: getCurrentLocalDateTime(new Date("2021-01-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-10")).isoDateTime,
        toDayTestGenLoan: "2021-01-10",
      },
      {
        name: "ณัฐรดี",
        lastname: "งับสันเทียะ",
        citizenid: "1770500075257",
        birthdateTh: "01/06/2539",
        currentAddress:
          "29/80 ซอย รัชดาภิเษก 30 แยก 1-1 แขวง จันทรเกษม เขต จตุจักร จ.กรุงเทพฯ 10900",
        period: 3,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "02",
        phone_number: "0911695567",
        bankNo: "1028871240",
        request_id: getCurrentLocalDateTime(new Date("2016-01-01")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2016-01-01")).isoDateTime,
        toDayTestGenLoan: "2016-01-01",
      },
      {
        name: "ภัทรมน",
        lastname: "สุคนธปฏิภาค",
        citizenid: "1104200098749",
        birthdateTh: "01/06/2532",
        currentAddress:
          "34/4 ซอยงามวงศ์วาน47 แยก10-1 แขวงทุ่งสองห้อง เขตหลักสี่ จ.กรุงเทพฯ 10210",
        period: 3,
        requestamount: 5000,
        payPerMonth: 5000,
        completedAt: "10",
        phone_number: "0896949161",
        bankNo: "1011519438",
        request_id: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-05-10")).isoDateTime,
        toDayTestGenLoan: "2021-05-10",
      },
      {
        name: "พรธัญรัฐ",
        lastname: "ศิริปุลินพงศ์",
        citizenid: "1100400970675",
        birthdateTh: "01/06/2531",
        currentAddress:
          "29/164 หมู่บ้านวรารักษ์ ซอย 2/5 ต.คลองสาม อ.คลองหลวง จ.ปทุมธานี 12120",
        period: 12,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        phone_number: "0819595354",
        bankNo: "1018500236",
        request_id: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-03-15")).isoDateTime,
        toDayTestGenLoan: "2021-03-15",
      },
      {
        name: "ชไมพร",
        lastname: "พรมเมือง",
        citizenid: "1480200064597",
        birthdateTh: "01/06/2531",
        currentAddress:
          "21 ส.เจริญคอร์ต ถ.พหลโยธิน แขวงพญาไท เขตพญาไท จ.กรุงเทพฯ 10400",
        period: 3,
        requestamount: 15000,
        payPerMonth: 15000,
        completedAt: "9",
        phone_number: "0661469544",
        bankNo: "1001160423",
        request_id: getCurrentLocalDateTime(new Date("2021-02-09")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-02-09")).isoDateTime,
        toDayTestGenLoan: "2021-02-09",
      },
      {
        name: "วรนภ",
        lastname: "พึ่งมา",
        citizenid: "1102003042374",
        birthdateTh: "01/06/2531",
        currentAddress: "22/2 หมู่ 10 ต.คลองข่อย อ.ปากเกร็ด จ.นนทบุรี 11120",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "12",
        phone_number: "0830392176",
        bankNo: "0218062210",
        request_id: getCurrentLocalDateTime(new Date("2021-01-12")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-01-12")).isoDateTime,
        toDayTestGenLoan: "2021-01-12",
      },
      {
        name: "ปิยพร",
        lastname: "จงจิตร",
        citizenid: "1103701842636",
        birthdateTh: "01/06/2531",
        currentAddress:
          "95 ลาดพร้าวซอย 8 ถนนลาดพร้าว แขวงจอมพล เขตจตุจักร จ.กรุงเทพฯ 10900",
        period: 3,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "15",
        phone_number: "0838290092",
        bankNo: "1018868012",
        request_id: getCurrentLocalDateTime(new Date("2020-12-15")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-12-15")).isoDateTime,
        toDayTestGenLoan: "2020-12-15",
      },
      {
        name: "นุชจรินทร์",
        lastname: "คงเกษม",
        citizenid: "1100501029114",
        birthdateTh: "01/06/2533",
        currentAddress:
          "53/586 หมู่13 ถนนพหลโยธิน ต.คลองหนึ่ง อ.คลองหลวง จ.ปทุมธานี 12120",
        period: 12,
        requestamount: 16000,
        payPerMonth: 16000,
        completedAt: "5",
        phone_number: "0972505710",
        bankNo: "0933939707",
        request_id: getCurrentLocalDateTime(new Date("2020-11-05")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-11-05")).isoDateTime,
        toDayTestGenLoan: "2020-11-05",
      },
      {
        name: "สมชาย",
        lastname: "จันทปัญญา",
        citizenid: "1321000011386",
        birthdateTh: "01/06/2533",
        currentAddress:
          "112/185 หมู่ 8 ซ.หนามแดง ถ.ศรีนครินทร์ ต.บางแก้ว อ.บางพลี จ.สมุทรปราการ 10450",
        period: 3,
        requestamount: 9000,
        payPerMonth: 9000,
        completedAt: "9",
        phone_number: "0865475890",
        bankNo: "5982246476",
        request_id: getCurrentLocalDateTime(new Date("2020-10-09")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-10-09")).isoDateTime,
        toDayTestGenLoan: "2020-10-09",
      },
      {
        name: "ณัฐญา",
        lastname: "ผลพืชน์",
        citizenid: "1100500512253",
        birthdateTh: "01/06/2528",
        currentAddress: "641 แชวงบางมด เขตทุ่งครุ จ.กรุงเทพฯ 10140",
        period: 6,
        requestamount: 6000,
        payPerMonth: 6000,
        completedAt: "10",
        phone_number: "0841686642",
        bankNo: "1001323314",
        request_id: getCurrentLocalDateTime(new Date("2020-09-10")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-09-10")).isoDateTime,
        toDayTestGenLoan: "2020-09-10",
      },
      {
        name: "ณภัสวรรณ",
        lastname: "ทองคำ",
        citizenid: "1349900862606",
        birthdateTh: "01/06/2536",
        currentAddress:
          "เลขที่ 3 อาคาร ลุมพินีวิลล์ คอนโด แขวง อนุสาวรีย์ เขต บางเขน กรุงเทพ 10220",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "13",
        phone_number: "0831288535",
        bankNo: "4340673583",
        request_id: getCurrentLocalDateTime(new Date("2020-08-13")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-08-13")).isoDateTime,
        toDayTestGenLoan: "2020-08-13",
      },
      {
        name: "อานุภาพ",
        lastname: "สุขเสริม",
        citizenid: "2419901070701",
        birthdateTh: "01/06/2536",
        currentAddress: "160 ลาดพร้าว 101 แยก 50 แขวงคลองจั่น เขตบางกะปิ 10240",
        period: 12,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "11",
        phone_number: "0900318990",
        bankNo: "7302900668",
        request_id: getCurrentLocalDateTime(new Date("2020-07-11")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2020-07-11")).isoDateTime,
        toDayTestGenLoan: "2020-07-11",
      },
      {
        name: "พรเทพ",
        lastname: "จันทร์มี",
        citizenid: "1112770356213",
        birthdateTh: "01/06/2538",
        currentAddress: "265/195 สิวลีรามคำแหง เขตสะพานสูง แขวงสะพานสูง 10240",
        period: 6,
        requestamount: 12000,
        payPerMonth: 12000,
        completedAt: "20",
        phone_number: "0877908161",
        bankNo: "4100462910",
        request_id: getCurrentLocalDateTime(new Date("2021-04-20")).isoDateTime,
        dueTime: getCurrentLocalDateTime(new Date("2021-04-20")).isoDateTime,
        toDayTestGenLoan: "2021-04-20",
      },
    ];

    await Promise.all(
      data2.map(async (item, index) => {
        if (
          index === 0
          // index === 1 ||
          // index === 2 ||
          // index === 3 ||
          // index === 4 ||
          // index === 5
        ) {
          await API.post("MoneyHubAdmin", "/loan", {
            body: {
              ...item,
              // phone_number: `08${
              //   Math.floor(Math.random() * 99999999) + 10000000
              // }`,
              // bankNo: _.toString(
              //   Math.floor(Math.random() * 9999999999) + 1000000000
              // ),
              purpose: "ธุรกิจ",
              fullname: `${item.name} ${item.lastname}`,
              promo: 0,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        }
      })
    );
    // await API.post("MoneyHubAdmin", "/loan", {
    //   body: {
    //     // phone_number: `08${Math.floor(Math.random() * 99999999) + 10000000}`,
    //     // phone_number: `0877908161`,
    //     // bankNo: _.toString(Math.floor(Math.random() * 9999999999) + 1000000000),
    //     // citizenid: _.toString(
    //     //   Math.floor(Math.random() * 9999999999999) + 1000000000000
    //     // ),
    //     // birthdateTh: `${pad(Math.floor(Math.random() * 11))}/${pad(
    //     //   Math.floor(Math.random() * 13)
    //     // )}/${pad(Math.floor(Math.random() * 91)) + 1930}`,
    //     currentAddress: "ดินแดง,ดินแดง,กรุงเทพมหานคร,10400",
    //     request_id: getCurrentLocalDateTime(new Date()).isoDateTime,
    //     purpose: ranPurposeList[ranPurposeIndex],
    //     period: +ranPeriodList[ranPeriodIndex],
    //     requestamount: +ranRequestAmountList[ranRequestAmountIndex],
    //     payPerMonth: +ranRequestAmountList[ranRequestAmountIndex],
    //     completedAt: executeTime,
    //     dueTime: getCurrentLocalDateTime(new Date()).isoDateTime,
    //     fullname: `${name} ${lastname}`,
    //     name: name,
    //     lastname: lastname,
    //     promo: 0,
    //     toDayTestGenLoan: currentDate,
    //   },
    //   headers: {
    //     Authorization: `Bearer ${(await Auth.currentSession())
    //       .getIdToken()
    //       .getJwtToken()}`,
    //   },
    // });
    await getData(query);
  };

  const onClickResetFilter = async () => {
    setQuery(DEFAULT_QUERY);
    dispatch(onChangeSearchBar(""));
    setSearchBy("phone_number");
    setPageIndex(0);
    setPageType(null);
    await getData(DEFAULT_QUERY);
    await getDataCount(DEFAULT_QUERY);
  };

  const getExclusiveStartKey = (index) => {
    if (query.request_id) {
      return `loan_id=${datas[index].loan_id}&loan_kbank_id=${datas[index].loan_kbank_id}`;
    } else if (query.status === "All" || query.status === "LATE") {
      return `isCreated=true&loan_id=${datas[index].loan_id}`;
    } else if (query.name) {
      return `loan_id=${datas[index].loan_id}&timestamp=${datas[index].timestamp}&name=${datas[index].name}`;
    } else if (query.requestamount) {
      return `loan_id=${datas[index].loan_id}&timestamp=${datas[index].timestamp}&requestamount=${datas[index].requestamount}`;
    } else if (query.phone_number) {
      return `loan_id=${datas[index].loan_id}&timestamp=${datas[index].timestamp}phone_number=${datas[index].phone_number}`;
    }
    return `loan_status=${datas[index].loan_status}&loan_id=${datas[index].loan_id}`;
  };

  const getExclusiveStartKeyAll = (index, datas = []) => {
    if (query.request_id) {
      return `loan_id=${datas[index].loan_id}&loan_kbank_id=${datas[index].loan_kbank_id}`;
    } else if (query.status === "All" || query.status === "LATE") {
      return `isCreated=true&loan_id=${datas[index].loan_id}`;
    } else if (query.name) {
      return `loan_id=${datas[index].loan_id}&timestamp=${datas[index].timestamp}&name=${datas[index].name}`;
    } else if (query.requestamount) {
      return `loan_id=${datas[index].loan_id}&timestamp=${datas[index].timestamp}&requestamount=${datas[index].requestamount}`;
    } else if (query.phone_number) {
      return `loan_id=${datas[index].loan_id}&timestamp=${datas[index].timestamp}phone_number=${datas[index].phone_number}`;
    }
    return `loan_status=${datas[index].loan_status}&loan_id=${datas[index].loan_id}`;
  };

  const onChangeLimit = async (e) => {
    setPageSize(e);
    setPageIndex(0);
    let newQuery = {
      ...query,
      Limit: e.value,
    };
    delete newQuery?.ExclusiveStartKey;
    setQuery(newQuery);
    await getData(newQuery);
  };

  const onClickPrevPage = async () => {
    let newQuery = {
      ...query,
      Limit: +pageSize.value,
      countData: 1,
      ScanIndexForward: true,
    };
    if (pageType === "NEXT" && !datas.length) {
      newQuery = {
        ...newQuery,
      };
    } else {
      newQuery = {
        ...newQuery,
        ExclusiveStartKey: getExclusiveStartKey(0),
      };
    }
    setPageIndex((prev) => prev - 1);
    setPageType("PREV");
    await getData(newQuery, { sortBy: true, isLoading: true });
  };

  const onClickNextPage = async () => {
    const lastIndex = datas.length - 1;
    const newQuery = {
      ...query,
      countData: 1,
      ScanIndexForward: false,
      Limit: +pageSize.value,
      ExclusiveStartKey: getExclusiveStartKey(lastIndex),
    };
    setPageIndex((prev) => prev + 1);
    setPageType("NEXT");
    await getData(newQuery, { isLoading: true });
  };

  const onSubmitFilter = async () => {
    SubmitLocalStorageSearch(searchBar);
    setPageIndex(0);
    setCountAutoMail(0);
    setPageType(null);
    let newQuery = {
      ...query,
    };
    delete newQuery?.request_id;
    delete newQuery?.name;
    delete newQuery?.adminName;
    delete newQuery?.requestamount;
    delete newQuery?.phone_number;
    if (searchBar.value) {
      newQuery = {
        ...newQuery,
        [searchBy]: searchBar.value,
      };
    }
    //  else {
    //   delete newQuery?.request_id;
    //   delete newQuery?.name;
    //   delete newQuery?.adminName;
    //   delete newQuery?.requestamount;
    //   delete newQuery?.phone_number;
    // }
    delete newQuery?.ExclusiveStartKey;

    setCurrentType(newQuery.status);
    setQuery(newQuery);
    await getData(newQuery);
    await getDataCount(newQuery);
    // setStopped(true)
  };

  const getOption = (options, value) => {
    const findIndex = options.findIndex((option) => option.value === value);
    return options[findIndex];
  };

  Font.register({
    family: "Sarabun",
    fonts: [{ src: font }, { src: fontBold }],
  });

  Font.register({
    family: "Cordia New",
    fonts: [{ src: fontCodia }, { src: fontBoldCodia }],
  });

  var isProcessing = false;

  const styles = StyleSheet.create({
    page: {
      fontFamily: "Sarabun",
      padding: 24,
      fontSize: 12,
      backgroundColor: "#fff",
    },
    content: {
      paddingHorizontal: 16,
      // textIndent: 18
    },
    date: {
      marginTop: 3,
      marginBottom: 20,
      textAlign: "center",
    },
    header: {
      fontSize: 12,
      textAlign: "center",
    },
    text: {
      margin: 12,
      fontSize: 12,
      lineHeight: 1.6,
      // marginVertical: 4,
      // fontSize: 12,
      fontFamily: "Sarabun",
    },
    textContent: {
      maginTop: 18,
      marginBottom: 18,
      lineHeight: 1.6,
      fontFamily: "Sarabun",
    },
    bold: {
      fontFamily: "Sarabun",
      fontWeight: "bold",
      lineHeight: 1.6,
    },
    address: {
      textAlign: "right",
      marginVertical: 16,
    },
  });

  const getNumberText = (value, concat = "") => {
    if (value % 10 >= 9) return "เก้า" + concat;
    if (value % 10 >= 8) return "แปด" + concat;
    if (value % 10 >= 7) return "เจ็ด" + concat;
    if (value % 10 >= 6) return "หก" + concat;
    if (value % 10 >= 5) return "ห้า" + concat;
    if (value % 10 >= 4) return "สี่" + concat;
    if (value % 10 >= 3) return "สาม" + concat;
    if (value % 10 >= 2) return "สอง" + concat;
    if (value % 10 >= 1) return "หนึ่ง" + concat;
    return "";
  };

  const getThaiAmount = (value = 1819) => {
    var grand = value / 10000;
    var thounsand = value / 1000;
    var hundred = value / 100;
    var deci = value / 10;
    var last = value % 10;
    var lastText = getNumberText(last);
    var deciText = getNumberText(deci, "สิบ");
    if (deci >= 1 && deci < 2) deciText = "สิบ";
    if (deci == 2) deciText = "ยี่สิบ";
    var hundredText = getNumberText(hundred, "ร้อย");
    var thounsandText = getNumberText(thounsand, "พัน");
    var grandText = getNumberText(grand, "หมื่น");
    if (last == 1) lastText = "เอ็ด";
    return (
      grandText + thounsandText + hundredText + deciText + lastText + "บาทถ้วน"
    );
  };

  const PdfDocument = ({ isFirst = false, interests }) => {
    return (
      <Document>
        {selectedRows.map((row, index) => {
          const {
            name,
            lastname,
            loan_kbank_id,
            requestTime,
            overdue_date,
            installments,
            interestMore,
            requestamount,
            type,
          } = row.original;

          //  console.log("ROW", row);

          const currentInterest = interests.find(
            (interest) => interest.type === type
          );

          const fullname = `${name} ${lastname}`;

          var now_th = moment.locale("th");
          var today = moment().add(543, "year").format("DD/MM/YYYY");
          var currentDate = moment().date();
          var currentYear = moment().add(543, "year").year();
          var rawMonth = moment().format("MM");
          var currentMonth = "มกราคม";
          if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
          if (rawMonth == "03") currentMonth = "มีนาคม";
          if (rawMonth == "04") currentMonth = "เมษายน";
          if (rawMonth == "05") currentMonth = "พฤษภาคม";
          if (rawMonth == "06") currentMonth = "มิถุนายน";
          if (rawMonth == "07") currentMonth = "กรกฎาคม";
          if (rawMonth == "08") currentMonth = "สิงหาคม";
          if (rawMonth == "09") currentMonth = "กันยายน";
          if (rawMonth == "10") currentMonth = "ตุลาคม";
          if (rawMonth == "11") currentMonth = "พฤศจิกายน";
          if (rawMonth == "12") currentMonth = "ธันวาคม";

          const convertRequestTime = getCurrentLocalDateTime(
            new Date(requestTime)
          );
          const overdueDate = getCurrentLocalDateTime(new Date(overdue_date));
          const owedDue =
            installments
              .filter(
                (installment) =>
                  installment.date < format(new Date(), "yyyy-MM-dd")
              )
              .reduce((prev, installment) => {
                return prev + installment.actualPrinciple;
              }, 0) + interestMore;

          return (
            <Page size="A4" style={styles.page}>
              <Text style={styles.header}>
                หนังสือบอกกล่าวทวงถามให้ชำระหนี้ครั้งที่ {isFirst ? "1" : "2"}{" "}
              </Text>
              <View style={styles.content}>
                <View style={styles.address}>
                  <Text>
                    ทำที่ 1010 อาคารชินวัตรทาวเวอร์ 3 ชั้นที่ 12
                    ถนนวิภาวดีรังสิต{" "}
                  </Text>
                  <Text>แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร </Text>
                </View>

                <View style={styles.date}>
                  <Text>
                    วันที่ {currentDate} เดือน {currentMonth} ปี {currentYear}
                  </Text>
                </View>

                <View style={{ maginTop: 16, marginBottom: 16 }}>
                  <Text style={styles.textContent}>
                    <Text style={styles.bold}>เรียน</Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Text style={styles.text}>คุณ {fullname} </Text>
                    <Text style={styles.bold}>("ผู้กู้")</Text>
                  </Text>

                  <Text style={styles.textContent}>
                    <Text style={styles.bold}>เรื่อง</Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Text style={styles.text}>
                      ขอให้ชำระหนี้ค้างชำระตามสัญญาสินเชื่อ{" "}
                    </Text>
                  </Text>

                  <Text style={styles.textContent}>
                    <Text style={styles.bold}>อ้างถึง</Text>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <Text style={{ ...styles.text }}>
                      สัญญาสินเชื่อ เลขที่ {loan_kbank_id} ฉบับลงวันที่{" "}
                      {convertRequestTime.date}{" "}
                      {months[convertRequestTime.monthIndex].monthTh}{" "}
                      {+convertRequestTime.year + 543} ระหว่าง ผู้กู้ และ บริษัท
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;มันนี่
                      ฮับ เซอร์วิส จำกัด ("บริษัท" หรือ "ผู้ให้กู้")
                      ("สัญญาสินเชื่อ"){" "}
                    </Text>
                  </Text>
                </View>

                <Text style={{ ...styles.textContent, textAlign: "left" }}>
                  <Text style={styles.bold}>สิ่งที่ส่งมาด้วย&nbsp;</Text>
                  <Text>
                    &nbsp;&nbsp;ใบแจ้งยอดรายการและภาระหนี้ ฉบับลงวันที่{" "}
                    {overdueDate.date}
                    &nbsp;
                    {months[overdueDate.monthIndex].monthTh}&nbsp;
                    {+overdueDate.year + 543} ออกโดยบริษัท ถึง ผู้กู้{" "}
                  </Text>
                  <View></View>
                  <Text>
                    (แสดงภาระหนี้ค้างชำระรวมเป็นเงินจำนวนทั้งสิ้น&nbsp;
                    {numeral(owedDue).format("0,0.00")} บาท ทั้งนี้
                    หนี้ค้างชำระดังกล่าวยังไม่รวมค่าใช้จ่ายใดๆ
                    ในการดำเนินการติดตามทวงถามหนี้ ){" "}
                  </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    ตามสัญญาสินเชื่อที่อ้างถึง ท่าน ในฐานะผู้กู้
                    ได้เข้าทำสัญญาสินเชื่อกับบริษัท มันนี่ ฮับ เซอร์วิส{" "}
                  </Text>
                  <Text break={false}>
                    จำกัด ในฐานะผู้ให้กู้ และกู้ยืมเงินไปจากบริษัท
                    ในฐานะผู้ให้กู้ เป็นเงินจำนวน{" "}
                    {numeral(requestamount).format("0,0.00")} บาท (
                    {getThaiAmount(requestamount)})
                  </Text>
                  <View></View>
                  <View></View>

                  <Text>
                    &nbsp;โดยท่านตกลงชำระดอกเบี้ยในอัตราร้อยละ{" "}
                    {currentInterest.value}% ต่อปีของต้นเงินดังกล่าว{" "}
                  </Text>
                  <Text>รายละเอียดปรากฎตามสัญญาสินเชื่อ </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                    textIndent: 30,
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    บริษัทขอเรียนให้ท่านทราบว่า
                    ท่านมียอดหนี้ค้างชำระตามสัญญาสินเชื่อซึ่งเลยกำหนดชำระและพึง&nbsp;&nbsp;{" "}
                  </Text>
                  <Text>
                    ต้องชำระให้แก่บริษัท เป็นจำนวนทั้งสิ้น{" "}
                    {numeral(owedDue).format("0,0.00")} บาท
                  </Text>
                  <Text>
                    &nbsp;({getThaiAmount(owedDue)}) รายละเอียดภาระหนี้ค้าง{" "}
                  </Text>
                  <Text>
                    ชำระและรายละเอียดการคำนวณภาระหนี้ปรากฏตามใบแจ้งยอดรายการและภาระหนี้ที่ได้แนบท้ายมากับ&nbsp;{" "}
                  </Text>
                  <Text>
                    หนังสือฉบับนี้ (ทั้งนี้
                    หนี้ค้างชำระดังกล่าวยังไม่รวมค่าใช้จ่ายใด ๆ
                    ในการดำเนินการติดตามทวงถามหนี้ ซึ่ง &nbsp;{" "}
                  </Text>
                  <Text>บริษัทจะเรียกเก็บจากท่าน (หากมี) ต่อไป) </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                    textIndent: 30,
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    โดยหนังสือบอกกล่าวทวงถามให้ชำระหนี้
                    <Text style={styles.bold}> ("หนังสือฉบับนี้") </Text>{" "}
                    บริษัทจึงเรียนมายังท่านเพื่อขอให้ท่านชำระ{" "}
                  </Text>
                  <Text>
                    หนี้ค้างชำระจำนวนดังกล่าวทั้งหมดให้แก่บริษัทตามรูปแบบการชำระเงินและผ่านช่องทางการ
                    &nbsp;&nbsp;&nbsp;
                  </Text>
                  <Text>
                    ชำระต่างๆที่ระบุในใบแจ้งยอดรายการและภาระหนี้ที่แนบมานี้{" "}
                    {isFirst ? "ภายใน 7 " : "อย่างเร็วที่สุด ภายใน 3 "}
                    วัน นับจากวันที่ได้รับหนังสือ ฉบับนี้
                  </Text>
                  <Text
                    style={{ ...styles.bold, textDecoration: "underline" }}
                    break={true}
                  >
                    &nbsp;หากบริษัทยังไม่ได้รับชำระหนี้จากท่านเมื่อพ้นระยะเวลาดังกล่าวแล้วบริษัท
                    {isFirst ? "" : "\n"}มีความจำเป็นที่อาจจะ
                    {isFirst ? "\n" : ""}
                    ต้องดำเนินการตามสัญญาและ/หรือดำเนินการบังคับชำระหนี้จากท่านตามกฎหมาย
                    {isFirst ? " " : "\n"}ต่อไป อนึ่ง หากท่าน{" "}
                    {isFirst ? "\n" : " "}ได้
                    มีการชำระหนี้ให้แก่บริษัทแล้วก่อนได้รับหนังสือฉบับนี้บริษัทต้องขออภัย
                    เป็นอย่างสูงมา ณ โอกาสนี้ด้วย&nbsp;&nbsp; {"\n"}
                  </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    หากหนังสือฉบับนี้ส่งโดยจดหมายอิเล็กทรอนิกส์โดยสื่ออิเล็กทรอนิกส์หรือโดยสื่อเทคโนโลยี{" "}
                  </Text>

                  <Text>
                    สารสนเทศประเภทอื่นก็ไม่กระทบต่อความสมบูรณ์หรือผลบังคับของหนังสือฉบับนี้
                    และให้ถือว่าหนังสือ{" "}
                  </Text>

                  <Text>
                    ฉบับนี้ที่ส่งทางจดหมายอิเล็กทรอนิกส์ โดยสื่ออิเล็กทรอนิกส์
                    หรือโดยสื่อเทคโนโลยีสารสนเทศประเภท{" "}
                  </Text>

                  <Text>อื่นดังกล่าว เป็นต้นฉบับ </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    textAlign: "justify",
                  }}
                >
                  <Text style={{ textIndent: 30 }}>
                    เมื่อท่านได้รับหนังสือฉบับนี้แล้วบริษัทขอให้ท่านตรวจสอบยอดหนี้ค้างชำระและรายละเอียดที่{" "}
                  </Text>

                  <Text>
                    ระบุในหนังสือฉบับนี้และตามใบแจ้งยอดรายการและภาระหนี้ที่แนบท้ายหนังสือฉบับนี้หากท่านมี{" "}
                  </Text>

                  <Text>
                    ข้อโต้แย้งหรือเรื่องร้องเรียนใด ๆ
                    กรุณาติดต่อมายังบริษัทภายใน {isFirst ? "7" : "3"} วัน{" "}
                  </Text>
                </Text>

                <Text
                  style={{
                    ...styles.textContent,
                    marginTop: 16,
                    textAlign: "center",
                  }}
                >
                  จึงเรียนมาเพื่อโปรดดำเนินการโดยเร็ว{" "}
                </Text>

                <View
                  style={{
                    ...styles.textContent,
                    marginTop: 24,
                    textAlign: "center",
                  }}
                >
                  <Text>ขอแสดงความนับถือ </Text>
                  <Text>ลงนามเพื่อและในนามของ </Text>
                  <Text style={styles.bold}>
                    บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                </View>

                <View
                  style={{
                    ...styles.textContent,
                    marginTop: 24,
                    textAlign: "center",
                  }}
                >
                  <Text>โดย_________________________ </Text>
                  <Text>ชื่อ:_________________________ </Text>
                  <Text>ตำแหน่ง: ผู้จัดการฝ่ายเร่งรัดหนี้สิน </Text>
                  <Text>
                    (โดยหนังสือมอบอำนาจ ฉบับลงวันที่ {currentDate}{" "}
                    {currentMonth} {currentYear}){" "}
                  </Text>
                </View>

                <View
                  style={{
                    ...styles.textContent,
                    marginTop: 20,
                    textAlign: "left",
                  }}
                >
                  <Text style={styles.bold}>หมายเหตุ : </Text>
                  <Text>
                    สอบถามรายละเอียดเพิ่มเติม ติดต่อศูนย์บริการลูกค้า บริษัท
                    มันนี่ ฮับ เซอร์วิส จำกัด{" "}
                  </Text>
                  <Text>
                    โทร 02-791-1300 วันเวลาทำการ 08:30-17:30 น. หรือ
                    ติดต่อฝ่ายเร่งรัดหนี้สิน โทร 02-791-1300{" "}
                  </Text>
                </View>
              </View>
            </Page>
          );
        })}
      </Document>
    );
  };

  const generatePdfDocument = async (isFirst = false) => {
    if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
    else isProcessing = true;

    const { body } = await API.get("MoneyHubAdmin", "/interest", {
      queryStringParameters: {},
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
    });

    let filename = `EXPORT_${
      isFirst ? "first" : "secound"
    }_${new Date().toISOString()}.pdf`;

    const interests = JSON.parse(body).Items;

    /// Cal increment Lamba to get Count here
    try {
      let blob = await pdf(
        <PdfDocument interests={interests} title={filename} isFirst={isFirst} />
      ).toBlob();
      saveAs(blob, filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
  };

  const stylesBuro = StyleSheet.create({
    page: {
      fontFamily: "Sarabun",
      padding: 26,
      fontSize: 12,
      backgroundColor: "#fff",
    },
    bold: {
      fontFamily: "Sarabun",
      fontWeight: "bold",
    },
    date: {
      textAlign: "right",
    },
    newLine: {
      marginTop: 32,
    },
    marginLeft: {
      marginLeft: 20,
    },
    betweenLine: {
      marginTop: 4,
    },
    header: {
      fontSize: 11,
      textAlign: "center",
    },
    red: {
      color: "red",
    },
    end: {
      textAlign: "right",
      marginRight: 32,
    },
    signature: {
      textAlign: "right",
      marginRight: 16,
      fontWeight: "bold",
    },
  });

  var isProcessing = false;

  Font.register({
    family: "Cordia New",
    fonts: [{ src: fontCodia }, { src: fontBoldCodia }],
  });

  const getThaiMonth = (rawMonth) => {
    var currentMonth = "มกราคม";
    if (rawMonth == "02") currentMonth = "กุมภาพันธ์";
    if (rawMonth == "03") currentMonth = "มีนาคม";
    if (rawMonth == "04") currentMonth = "เมษายน";
    if (rawMonth == "05") currentMonth = "พฤษภาคม";
    if (rawMonth == "06") currentMonth = "มิถุนายน";
    if (rawMonth == "07") currentMonth = "กรกฎาคม";
    if (rawMonth == "08") currentMonth = "สิงหาคม";
    if (rawMonth == "09") currentMonth = "กันยายน";
    if (rawMonth == "10") currentMonth = "ตุลาคม";
    if (rawMonth == "11") currentMonth = "พฤศจิกายน";
    if (rawMonth == "12") currentMonth = "ธันวาคม";
    return currentMonth;
  };

  const PdfBuro = ({ data, letter_id, index }) => {
    var now_th = moment.locale("th");
    var today = moment().add(543, "year").format("DD/MM/YYYY");
    var currentYear = moment().add(543, "year").year();
    var rawMonth = moment().format("MM");
    var currentMonth = getThaiMonth(rawMonth);
    var previousRawMonth = moment().add(-1, "month").format("MM");
    var previousYear = moment().add(543).add(-1, "month").year();
    var previousMonth = getThaiMonth(previousRawMonth);
    // var previousYear = Number(currentYear) - 1;
    var header = "หนังสือแจ้งครั้งแรกฉบับที่";

    return (
      <Page size="A4" style={stylesBuro.page}>
        <Text style={stylesBuro.header}>
          หนังสือแจ้งให้ลูกค้าทราบเกี่ยวกับการส่งข้อมูลให้แก่บริษัทข้อมูลเครดิต
          ({header}{" "}
          {(new Date().getFullYear() + 543).toString() +
            "/" +
            getCountString(+letter_id + index + 1)}
          )
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <View style={stylesBuro.betweenLine}></View>
        <Text style={stylesBuro.date}>วันที่ {today}</Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>เรียน คุณ {data.fullname}</Text>
        <View style={stylesBuro.newLine}></View>
        <Text style={stylesBuro.marginLeft}>
          ตามพระราชบัญญัติการประกอบธุรกิจขอมูลเครดิต พ.ศ. 2545
          และที่แก้ไขเพิ่มเติม และประกาศคณะกรรมการ
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          คุ้มครองข้อมูลเครดิต กำหนดไว้{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          มีหน้าที่ต้องส่งข้อมูลเครดิตของท่านให้แก่ บริษัท
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          ข้อมูลเครดิตแห่งชาติ จำกัด ที่{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          เป็นสมาชิกอยู่ และแจ้งให้ท่านทราบเกี่ยวกับข้อมูล
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          เครดิตที่ส่งไป ดังกล่าว ดังนั้น
          เพื่อดำเนินการให้เป็นไปตามบทบัญญัติของพระราชบัญญัติ ตลอดจนประกาศคณะ{" "}
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <View>
          <Text>
            กรรมการคุ้มครอง ข้อมูลเครดิตข้างต้น{" "}
            <Text style={stylesBuro.bold}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด{" "}
            </Text>
            จึงขอแจ้งให้ท่านทราบว่า ใน{" "}
            <Text style={stylesBuro.bold}>เดือน {currentMonth}</Text>
          </Text>
          <View style={stylesBuro.betweenLine}></View>
          <Text>
            <Text style={stylesBuro.bold}>
              ปี {currentYear} บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
            </Text>{" "}
            ได้ส่งข้อมูลเครดิตของท่าน ณ{" "}
            <Text style={stylesBuro.bold}>
              เดือน {previousMonth} ปี {previousYear}
            </Text>{" "}
            ให้แก่ บริษัท
          </Text>
          <View style={stylesBuro.betweenLine}></View>
          <Text>
            ข้อมูลเครดิตแห่งชาติ จำกัด แล้ว โดยข้อมูลเครดิตที่{" "}
            <Text style={stylesBuro.bold}>
              บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
            </Text>
            ส่งไปดังกล่าว มีรายละเอียด
          </Text>
          <View style={stylesBuro.betweenLine}></View>
          <Text> ส่งไปดังกล่าว มีรายละเอียด ปรากฎท้ายหนังสือนี้ </Text>
        </View>

        <View style={stylesBuro.betweenLine}></View>
        <View style={stylesBuro.betweenLine}></View>
        <View style={stylesBuro.betweenLine}></View>
        <View style={stylesBuro.betweenLine}></View>
        <View style={stylesBuro.betweenLine}></View>
        <Text style={stylesBuro.marginLeft}>
          {" "}
          ทั้งนี้ ข้อมูลเครดิตที่{" "}
          <Text style={stylesBuro.bold}>
            บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
          </Text>{" "}
          นำส่งให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ จำกัด{" "}
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          ดังกล่าว{" "}
          <Text style={stylesBuro.red}>แสดงรายละเอียดการชำระสินเชื่อ</Text>{" "}
          ที่ท่านมีกับ{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          เพียงสถานะล่าสุดในขณะที่{" "}
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          จัดทำข้อมูลเพื่อนำส่งข้อมูลเครดิตให้แก่ บริษัท ข้อมูลเครดิตแห่งชาติ
          จำกัด{" "}
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          ดังกล่าวเท่านั้น ซึ่งข้อมูลเครดิตดังกล่าวอาจแตกต่างจากข้อมูลที่{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          มีอยู่ในขณะนี้
        </Text>
        <View style={stylesBuro.newLine}></View>

        <Text style={stylesBuro.marginLeft}>
          จึงเรียนมาเพื่อโปรดทราบ หากท่านมีข้อสงสัย หรือข้อสอบถาม โปรด
        </Text>
        <View style={stylesBuro.betweenLine}></View>
        <Text>
          ติดต่อ{" "}
          <Text style={stylesBuro.bold}>บริษัท มันนี่ ฮับ เซอร์วิส จำกัด</Text>{" "}
          โทรศัพท์ 02-791-1300
        </Text>
        <View style={stylesBuro.newLine}></View>
        <Text style={stylesBuro.end}>ขอแสดงความนับถือ</Text>
        <View style={stylesBuro.betweenLine}></View>
        <View style={stylesBuro.betweenLine}></View>
        <Text style={stylesBuro.signature}>
          บริษัท มันนี่ ฮับ เซอร์วิส จำกัด
        </Text>
      </Page>
    );
  };

  const PdfDocumentInstallment = ({ letter_id, newDatas, row, index }) => {
    return (
      <Document>
        <PdfInstallment data={row} />
        {/* <PdfBuro data={row} letter_id={letter_id} index={index} /> */}
      </Document>
    );
  };

  const PdfDocumentInstallment2 = ({ letter_id, newDatas, row, index }) => {
    return (
      <Document>
        <PdfInstallment2 data={row} />
        {/* <PdfBuro data={row} letter_id={letter_id} index={index} /> */}
      </Document>
    );
  };

  const generatePdfDocumentInstallment = async () => {
    setLoadingPdf(true);
    if (isProcessing) {
      toast.warn("กำลังทำรายการโปรดรอสักครู่");
      return;
    } else isProcessing = true;

    const count = await API.put("MoneyHubAdmin", `/letterCount`, {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
      body: {
        addCount: selectedRows.length,
      },
    });
    const countLatest = Number(count) - selectedRows.length;

    let filename = `EXPORT_INSTALLMENT_${new Date().toISOString()}`;

    const merger = new PDFMerger();

    let index = 0;
    for (const row of selectedRows) {
      try {
        try {
          var urlBlob = await Storage.get(
            `${row.original.request_id}_contract.pdf`,
            {
              download: true,
            }
          );
        } catch (error) {
          var urlBlob = await Storage.get(
            `${row.original.request_id}_contract_final.pdf`,
            {
              download: true,
            }
          );
        }

        let file = new File(
          [urlBlob.Body],
          `${row.original.request_id}_contract.pdf`,
          { type: "pdf" }
        );

        await merger.add(file);
        let blob = await pdf(
          <PdfDocumentInstallment
            row={row.original}
            letter_id={countLatest}
            count={count}
            title={filename}
            index={index}
          />
        ).toBlob();
        await merger.add(blob);
      } catch (error) {
        continue;
      }
      index++;
    }

    try {
      await merger.save(filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
    setLoadingPdf(false);
  };

  const generatePdfDocumentInstallment2 = async () => {
    setLoadingPdf(true);
    if (isProcessing) {
      toast.warn("กำลังทำรายการโปรดรอสักครู่");
      return;
    } else isProcessing = true;

    const count = await API.put("MoneyHubAdmin", `/letterCount`, {
      headers: {
        Authorization: `Bearer ${(await Auth.currentSession())
          .getIdToken()
          .getJwtToken()}`,
      },
      body: {
        addCount: selectedRows.length,
      },
    });
    const countLatest = Number(count) - selectedRows.length;

    let filename = `EXPORT_INSTALLMENT_${new Date().toISOString()}`;

    const merger = new PDFMerger();

    let index = 0;
    for (const row of selectedRows) {
      try {
        try {
          var urlBlob = await Storage.get(
            `${row.original.request_id}_contract.pdf`,
            {
              download: true,
            }
          );
        } catch (error) {
          var urlBlob = await Storage.get(
            `${row.original.request_id}_contract_final.pdf`,
            {
              download: true,
            }
          );
        }

        let file = new File(
          [urlBlob.Body],
          `${row.original.request_id}_contract.pdf`,
          { type: "pdf" }
        );

        await merger.add(file);
        let blob = await pdf(
          <PdfDocumentInstallment2
            row={row.original}
            letter_id={countLatest}
            count={count}
            title={filename}
            index={index}
          />
        ).toBlob();
        await merger.add(blob);
      } catch (error) {
        continue;
      }
      index++;
    }

    try {
      await merger.save(filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
    setLoadingPdf(false);
  };

  const generatePdfBuro = async () => {
    setLoadingBuroPdf(true);
    if (isProcessing) {
      toast.warn("กำลังทำรายการโปรดรอสักครู่");
      return;
    } else isProcessing = true;

    let filename = `EXPORT_LETTER_BURO_${new Date().toISOString()}`;
    const merger = new PDFMerger();

    try {
      for (const row of selectedRows) {
        const dataBuro = getDetailSegment({
          currentDate: new Date(),
          dataExport: [row.original],
          showLog: true,
          logType: "KEY",
        });

        let blob = await pdf(
          <PdfBuroLetter dataPdf={dataBuro} oriLoan={row} />
        ).toBlob();
        await merger.add(blob);
      }

      await merger.save(filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      console.log("pdf buro error", error);
    } finally {
      setLoadingBuroPdf(false);
    }
  };

  const autoMail = async () => {
    try {
      setLoadingAutoMail(true);
      let datas = {};
      let count = 0;
      let lastItem = null;
      let allItems = [];

      do {
        datas = await API.get("MoneyHubAdmin", "/loan/count", {
          queryStringParameters: {
            ...query,
            ExclusiveStartKey: getLastItem(lastItem),
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        lastItem = datas?.body?.lastItem;
        count += datas?.body?.count;
        allItems = [...allItems, ...datas?.body?.loan];
        setCountAutoMail(count);
      } while (lastItem);

      allItems = allItems.map((item) => {
        return {
          ...item,
          job_no: item.loan_kbank_id,
        };
      });
      await sendEmail(allItems);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingAutoMail(false);
    }
  };

  const totalPage = Math.ceil(count / pageSize.value);
  const sliceNumber = 1;

  const paginationPages = new Array(1)?.fill(0)?.slice(0, sliceNumber);
  const canNextPage = pageIndex + 1 !== totalPage;
  const canPreviousPage = pageIndex !== 0;

  const headers = [
    { label: "Job No", key: "job_no" },
    { label: "ชื่อ", key: "fullname" },
    { label: "จำนวนงวด", key: "period" },
    { label: "ประเภทสินเชื่อ", key: "type" },
    { label: "เงินทุน", key: "initCapital" },
    { label: "เงินต้นคงเหลือ", key: "capitalRemain" },
    { label: "เบอร์โทร", key: "phone_number" },
    { label: "overDueDate", key: "overDueDate" },
    { label: "overDueDays", key: "overDueDays" },
  ];

  const dataCsv = selectedRows?.map((row) => {
    const { original } = row;

    const currentOverdue_date = getCurrentLocalDateTime(
      new Date(original.overdue_date)
    );
    const today = getCurrentLocalDateTime(new Date(overDueDate));

    return {
      ...original,
      job_no: original.loan_id,
      overDueDate: original?.overdue_date
        ? format(new Date(original.overdue_date), "dd-MM-yyyy")
        : "-",
      overDueDays: original?.overdue_date
        ? differenceInDays(today.timestamp, currentOverdue_date.timestamp)
        : "-",
    };
  });

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  const onImportExcel = async (importDatas, fileInfo) => {
    // console.log("importDatas", importDatas);
    // console.log(
    //   JSON.stringify(
    //     importDatas
    //       .filter((data) => data["เลขที่สัญญา"])
    //       .map((data) => {
    //         return `${data["เลขที่สัญญา"]}`;
    //       })
    //   )
    // );

    // for (const importData of importDatas) {
    //   await API.post("MoneyHubAdmin", `/loan/debtorSandbox`, {
    //     body: {
    //       reference_id: `${importData["เลขที่สัญญา"]}`,
    //     },
    //     headers: {
    //       Authorization: `Bearer ${(await Auth.currentSession())
    //         .getIdToken()
    //         .getJwtToken()}`,
    //     },
    //   });
    // }

    try {
      setLoadingImport(true);
      for (const importData of importDatas) {
        // console.log("IM", importData);
        await API.put("MoneyHubAdmin", `/loan/ems`, {
          body: {
            job_no: importData?.job_no,
            fullname: importData?.name,
            ems_first: importData?.ems_first,
            ems_first_buro: importData?.EMS_First_Buro,
            ems_year_buro: importData?.EMS_Year_Buro,
            ems_second: importData?.ems_second,
            ems_year: importData?.EMS_Year_Buro,
            ems_first_date: importData?.ems_first_date,
            ems_second_date: importData?.ems_second_date,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
      }
      await API.post("MoneyHubAdmin", `/fileExcel/historySync`, {
        body: {
          username: user.username,
          function_name: "IMPORT_LOAN",
          fileName: fileInfo.name,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await getData(query, { isLoading: false });
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const onDeleteImportExcel = async (importDatas, fileInfo) => {
    try {
      setLoadingImport(true);
      let listFound = [];
      for (const importData of importDatas) {
        const data = await API.del("MoneyHubAdmin", `/fileExcel/syncLoan`, {
          body: {
            importData,
            username: user.username,
            // job_no: importData?.job_no,
            // fullname: importData?.name,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        listFound.push(data.item);
      }
      await API.post("MoneyHubAdmin", `/fileExcel/notify`, {
        body: {
          listFound,
          username: user.username,
          importDatas,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await API.post("MoneyHubAdmin", `/fileExcel/historySync`, {
        body: {
          username: user.username,
          function_name: "DELETE_SYNC_LOAN",
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      await getData(query, { isLoading: false });
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const onDeleteLoan = async () => {
    try {
      setLoadingDelete(true);
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          try {
            for (const row of selectedRows) {
              await API.del("MoneyHubAdmin", `/loan/${row.original.loan_id}`, {
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              });
            }
          } catch (error) {
            await EmitterStatus("ERROR", { logMessage: error });
          }
        },
      });
      if (!result.isConfirmed) return;
      await EmitterStatus("SUCCESS");
      await getData(query);
      setSelectedRows([]);
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingDelete(false);
    }
  };

  const createDataWithStyle = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      const { overdue_date, loan_status } = data[i].original;

      let days = "";

      if (loan_status === "DONE") {
        days = "-";
      }

      const currentOverdue_date = getCurrentLocalDateTime(
        new Date(overdue_date)
      );

      const today = getCurrentLocalDateTime(new Date());

      const checkOverDueDate =
        currentOverdue_date.fullDate <= today.fullDate &&
        loan_status === "ACTIVE";

      if (checkOverDueDate) {
        days = `เกินกำหนด ${differenceInDays(
          today.timestamp,
          currentOverdue_date.timestamp
        )} วัน`;
      } else {
        days = "-";
      }

      result.push([
        {
          value: data[i].original.loan_kbank_id,
          style,
        },
        {
          value: data[i].original.ems_first || "-",
          style,
        },
        {
          value: data[i].original.ems_second || "-",
          style,
        },
        {
          value: data[i].original.name + " " + data[i].original.lastname,
          style,
        },
        {
          value: data[i].original.period,
          style,
        },
        {
          value: data[i].original.type,
          style,
        },
        {
          value: data[i].original.requestamount,
          style,
        },
        {
          value: data[i].original.capitalRemain,
          style,
        },
        {
          value: data[i].original.phone_number,
          style,
        },
        {
          value: format(new Date(data[i].original.requestTime), "dd-MM-yyyy"),
          style,
        },
        {
          value: data[i].original.updatedAt
            ? format(new Date(data[i].original.updatedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].original.loan_status,
          style,
        },
        {
          value: data[i].original.overdue_date
            ? format(new Date(data[i].original.overdue_date), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: days,
          style,
        },
        {
          value:
            data[i]?.original?.completedAt && data[i]?.original?.completedBy
              ? format(new Date(data[i].original.completedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i]?.original?.completedAt && data[i]?.original?.completedBy
              ? data[i].original.completedBy
              : "-",
          style,
        },
        {
          value:
            data[i]?.original?.approvedAt && data[i]?.original?.approvedBy
              ? format(new Date(data[i].original.approvedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i]?.original?.approvedAt && data[i]?.original?.approvedBy
              ? data[i].original.approvedBy
              : "-",
          style,
        },
        {
          value:
            data[i]?.original?.templateCreatedAt &&
            data[i]?.original?.templateCreatedAt
              ? format(
                  new Date(data[i].original.templateCreatedAt),
                  "dd-MM-yyyy"
                )
              : "-",
          style,
        },
      ]);
    }
    return result;
  };

  const createDataWithStyleAll = (data = []) => {
    var result = [];
    const borders = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };

    const style = {
      font: { sz: 14 },
      alignment: { vertical: "center", horizontal: "center" },
      // border: borders,
    };

    for (let i = 0; i < data.length; i++) {
      const { overdue_date, loan_status } = data[i];

      let days = "";

      if (loan_status === "DONE") {
        days = "-";
      }

      const currentOverdue_date = getCurrentLocalDateTime(
        new Date(overdue_date)
      );

      const today = getCurrentLocalDateTime(new Date());

      const checkOverDueDate =
        currentOverdue_date.fullDate <= today.fullDate &&
        loan_status === "ACTIVE";

      if (checkOverDueDate) {
        days = `เกินกำหนด ${differenceInDays(
          today.timestamp,
          currentOverdue_date.timestamp
        )} วัน`;
      } else {
        days = "-";
      }

      result.push([
        {
          value: data[i].loan_kbank_id || "",
          style,
        },
        {
          value: data[i].ems_first || "-",
          style,
        },
        {
          value: data[i].ems_second || "-",
          style,
        },
        {
          value: data[i].name + " " + data[i].lastname,
          style,
        },
        {
          value: data[i].period || "",
          style,
        },
        {
          value: data[i].type || "",
          style,
        },
        {
          value: data[i].requestamount || "",
          style,
        },
        {
          value: data[i].capitalRemain || "",
          style,
        },
        {
          value: data[i].phone_number || "",
          style,
        },
        {
          value: format(new Date(data[i].requestTime), "dd-MM-yyyy"),
          style,
        },
        {
          value: data[i].updatedAt
            ? format(new Date(data[i].updatedAt), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: data[i].loan_status || "",
          style,
        },
        {
          value: data[i].overdue_date
            ? format(new Date(data[i].overdue_date), "dd-MM-yyyy")
            : "-",
          style,
        },
        {
          value: days || "",
          style,
        },
        {
          value:
            data[i].completedAt && data[i].completedBy
              ? format(new Date(data[i].completedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i].completedAt && data[i].completedBy
              ? data[i].completedBy
              : "-",
          style,
        },
        {
          value:
            data[i].approvedAt && data[i].approvedBy
              ? format(new Date(data[i].approvedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
        {
          value:
            data[i].approvedAt && data[i].approvedBy ? data[i].approvedBy : "-",
          style,
        },
        {
          value:
            data[i].templateCreatedAt
              ? format(new Date(data[i].templateCreatedAt), "dd-MM-yyyy")
              : "-",
          style,
        },
      ]);
    }
    return result;
  };

  const style = {
    font: { sz: 16, name: "Cordia New" },
    alignment: { vertical: "center", horizontal: "center" },
    // borders: {
    //   top: { style: "thin" },
    //   bottom: { style: "thin" },
    //   left: { style: "thin" },
    //   right: { style: "thin" },
    // },
  };

  const onClickExport = () => {
    const exportClick = document.getElementById("loan");
    exportClick.click();
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: "Job no",
          width: { wch: 28 },
          style,
        }, //pixels width
        {
          title: "EMS FIRST",
          width: { wch: 38 },
          style,
        }, //pixels width
        {
          title: "EMS SECOND",
          width: { wch: 24 },
          style,
        }, //char width
        {
          title: "ชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 24 },
          style,
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "เงินทุน",
          width: { wch: 24 },
          style,
        },
        {
          title: "เงินต้นคงเหลือ",
          width: { wch: 24 },
          style,
        },
        {
          title: "เบอร์โทร",
          width: { wch: 36 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่แก้ไข",
          width: { wch: 24 },
          style,
        },
        {
          title: "สถานะ",
          width: { wch: 24 },
          style,
        },
        {
          title: "OverDueDate",
          width: { wch: 24 },
          style,
        },
        {
          title: "Days",
          width: { wch: 24 },
          style,
        },
        {
          title: "Complete Date",
          width: { wch: 24 },
          style,
        },
        {
          title: "Complete By",
          width: { wch: 24 },
          style,
        },
        {
          title: "Approve Date",
          width: { wch: 24 },
          style,
        },
        {
          title: "Approved By",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่ทำสัญญา",
          width: { wch: 24 },
          style,
        },
      ],
      data: createDataWithStyle(selectedRows),
    },
  ];

  const multiDataSetAll = [
    {
      columns: [
        {
          title: "Job no",
          width: { wch: 28 },
          style,
        }, //pixels width
        {
          title: "EMS FIRST",
          width: { wch: 38 },
          style,
        }, //pixels width
        {
          title: "EMS SECOND",
          width: { wch: 24 },
          style,
        }, //char width
        {
          title: "ชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "จำนวนงวด",
          width: { wch: 24 },
          style,
        },
        {
          title: "ประเภทสินเชื่อ",
          width: { wch: 24 },
          style,
        },
        {
          title: "เงินทุน",
          width: { wch: 24 },
          style,
        },
        {
          title: "เงินต้นคงเหลือ",
          width: { wch: 24 },
          style,
        },
        {
          title: "เบอร์โทร",
          width: { wch: 36 },
          style,
        },
        {
          title: "วันที่สร้าง",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่แก้ไข",
          width: { wch: 24 },
          style,
        },
        {
          title: "สถานะ",
          width: { wch: 24 },
          style,
        },
        {
          title: "OverDueDate",
          width: { wch: 24 },
          style,
        },
        {
          title: "Days",
          width: { wch: 24 },
          style,
        },
        {
          title: "Complete Date",
          width: { wch: 24 },
          style,
        },
        {
          title: "Complete By",
          width: { wch: 24 },
          style,
        },
        {
          title: "Approve Date",
          width: { wch: 24 },
          style,
        },
        {
          title: "Approved By",
          width: { wch: 24 },
          style,
        },
        {
          title: "วันที่ทำสัญญา",
          width: { wch: 24 },
          style,
        },
      ],
      data: createDataWithStyleAll(dataAll),
    },
  ];

  const refresh = async () => {
    let newQuery = {
      ...query,
    };
    await getData(newQuery);
    await getDataCount(newQuery);
  };

  const onClickExportAll = async () => {
    try {
      setLoadingExportAll(true);

      let keepData = [];

      let limit = 100;
      let ExclusiveStartKey = "";
      const cal_count = Math.ceil(countObj[currentType] / limit);
      for (let index = 0; index < cal_count; index++) {
        if (keepData.length > 0) {
          ExclusiveStartKey = getExclusiveStartKeyAll(
            keepData.length - 1,
            keepData
          );
        }
        const data = await API.get("MoneyHubAdmin", "/loan/exportAll", {
          queryStringParameters: {
            ...query,
            ScanIndexForward: false,
            Limit: limit,
            ExclusiveStartKey,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        keepData = [...keepData, ...data?.body.Items];
        setCountExport((prev) => (prev - limit < 0 ? 0 : prev - limit));
      }

      setDataAll(keepData);
      const exportClick = document.getElementById("loanExportAll");
      exportClick.click();
    } catch (error) {
      console.log("export all", error);
    } finally {
      setLoadingExportAll(false);
    }
  };

  const generatePdfDocumentEnvelope = async () => {
    if (isProcessing) toast.warn("กำลังทำรายการโปรดรอสักครู่");
    else isProcessing = true;

    let filename = `EXPORT_${new Date().toISOString()}.pdf`;

    /// Cal increment Lamba to get Count here
    try {
      let blob = await pdf(
        <PdfDocumentEnvelope title={filename} loan={selectedRows} />
      ).toBlob();
      saveAs(blob, filename);
      toast.success("ดาวโหลดสมบูรณ์");
      isProcessing = false;
    } catch (error) {
      alert(error);
      isProcessing = false;
    }
  };

  const onImportEmail = async (importDatas, fileInfo) => {
    try {
      // console.log("importDatas", importDatas);

      setLoadingImport(true);

      await sendEmail(importDatas);
      await getData(query, { isLoading: false });
      toast.success("ส่งอีเมลสำเร็จ");
    } catch (error) {
      console.log("import error", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const nextTimeOut = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  };

  const sendEmail = async (importDatas = []) => {
    let index = 0;
    for (const row of importDatas) {
      if (!row.job_no) continue;

      const merger = new PDFMerger();

      const data = await API.get(
        "MoneyHubAdmin",
        `/loan/reference/${row.job_no}`,
        {
          queryStringParameters: {
            paid_date: `${getCurrentLocalDateTime().year}-${
              getCurrentLocalDateTime().month
            }-${getCurrentLocalDateTime().date}`,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        }
      );

      if (!data?.body?.items?.length) {
        continue;
      }

      const item = data.body?.items[0];

      if (item.letter !== "1" || !item.email) {
        continue;
      }

      const count = await API.put("MoneyHubAdmin", `/letterCount`, {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
        body: {
          addCount: importDatas.length,
        },
      });

      const countLatest = Number(count) - importDatas.length;

      let now = new Date().getTime();
      let filename = `LOAN_${item.loan_kbank_id}_${now}`;

      let urlBlob = "";

      try {
        urlBlob = await Storage.get(`${item.request_id}_contract_final.pdf`, {
          download: true,
        });

        console.log("ITEM", item);
        console.log("URL BLOB", urlBlob?.Body);

        if (urlBlob?.Body?.size > 10000000) {
          const blob = await pdf(<GenFinalPdf data={item} />).toBlob();
          const filename = `${item.request_id}_gen_contract_final.pdf`;
          await Storage.put(filename, blob);
          urlBlob = await Storage.get(filename, {
            download: true,
          });
        }
      } catch (error) {
        console.log("not found final", error);
        const blob = await pdf(<GenFinalPdf data={item} />).toBlob();
        const filename = `${item.request_id}_gen_contract_final.pdf`;
        await Storage.put(filename, blob);
        urlBlob = await Storage.get(filename, {
          download: true,
        });

        // try {
        //   if (item.contractUri) {
        //     urlBlob = await Storage.get(`${item.contractUri}`, {
        //       download: true,
        //     });
        //   } else {
        //     urlBlob = await Storage.get(`${item.request_id}_contract.pdf`, {
        //       download: true,
        //     });
        //   }
        // } catch (error) {
        //   console.log("not found", error)
        //   continue;
        // }
      }

      let fileNameCondtion = "ขั้นตอนการแก้ไข กรณีเปิดไฟล์สัญญาสินเชื่อ.pdf";

      let urlCondition = await Storage.get(`${fileNameCondtion}`, {
        download: true,
      });

      // console.log("urlCondition", urlCondition);

      let fileCondtion = new File([urlCondition.Body], `${urlCondition}`, {
        type: "pdf",
      });

      let file = new File(
        [urlBlob.Body],
        `${item.request_id}_contract_final.pdf`,
        {
          type: "pdf",
        }
      );

      await merger.add(file);
      let blob = await pdf(
        <PdfDocumentInstallment
          row={item}
          letter_id={countLatest}
          count={count}
          title={filename}
          index={index}
        />
      ).toBlob();

      // const dataPdf = getDetailSegment({
      //   currentDate: new Date(),
      //   dataExport: [row],
      //   showLog: true,
      //   logType: "KEY",
      // });
      // let blobBuroPdf = await pdf(
      //   <PdfBuroLetter dataPdf={dataPdf} oriLoan={row} />
      // ).toBlob();
      // await merger.add(blobBuroPdf);

      await merger.add(blob);
      await merger.add(fileCondtion);

      const blobMerger = await merger.saveAsBuffer();

      var mz = new Minizip();

      const splitBirthDay = item.birthdateTh.split("/");
      let password = "";
      if (splitBirthDay?.length === 3) {
        const fulldate = `${splitBirthDay[2]}-${pad(splitBirthDay[1])}-${pad(
          splitBirthDay[0]
        )}`;
        password = format(new Date(fulldate), "ddMMyyyy");
      }

      mz.append(filename, blobMerger, { password });

      const fileNameZip = `LOAN_${item.loan_kbank_id}_${now}.zip`;

      const fileMerger = new File([mz.zip()], fileNameZip, {
        type: "application/x-zip-compressed",
      });

      await Storage.put(fileNameZip, fileMerger);
      const url = await Storage.get(fileNameZip);

      await API.post("MoneyHubAdmin", `/loan/sendEmail`, {
        body: {
          filename: fileNameZip,
          path: url,
          email: item?.email,
          loan_id: item?.loan_id,
          request_id: item?.request_id,
          reference_id: item?.loan_kbank_id,
          birthdateTh: item?.birthdateTh,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      console.log("--------------------------------------");
      await nextTimeOut();
      index++;
    }
  };

  const onSyncResend = async (importDatas = []) => {
    try {
      setLoadingImport(true);

      let listCount = 0;
      // importDatas = importDatas.slice(0, 1);
      for (const importData of importDatas) {
        const data = await API.post(
          "MoneyHubAdmin",
          `/fileExcel/importSyncPaymentReload`,
          {
            body: {
              reference1: importData.reference1,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          }
        );
        if (data.message === "S") {
          listCount++;
        }
      }
      console.log("list count", listCount);
      await getData(query, { isLoading: false });
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoadingImport(false);
    }
  };

  const onSyncAutoDate = async (importDatas) => {
    try {
      setLoadingImport(true);

      let listCount = 0;
      const today = new Date();
      today.setDate(today.getDate() + 1);

      let newToday = getCurrentLocalDateTime(new Date(today));
      const DOC_DATE = `${newToday.year}${pad(newToday.month)}${pad(
        newToday.date
      )}`;

      for (const importData of importDatas) {
        const data = await API.put("MoneyHubAdmin", `/fileExcel/syncAutoDate`, {
          body: {
            DOC_DATE,
            REFERENCE: importData.REFERENCE,
          },
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getIdToken()
              .getJwtToken()}`,
          },
        });
        if (data.message === "S") {
          listCount++;
        }
      }
      console.log("list count", listCount);
      await getData(query, { isLoading: false });
      toast.success("ซิงค์ข้อมูล CSV สมบูรณ์");
      console.log("importDatas", importDatas);
    } catch (error) {
      console.log("on sync auto date", error);
    } finally {
      setLoadingImport(false);
    }
  };

  return (
    <ContainerContent>
      <div className="mx-4 w-full mb-2 lg:flex items-center">
        {loadingImport && (
          <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
            <div className="w-2/5 h-auto mx-auto  ">
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: Loading,
                  isStopped: false,
                  isPaused: false,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
              />
              <div className="text-center text-white text-xl">
                กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
              </div>
            </div>
          </div>
        )}
        {/* fortest
        <div className="flex items-center my-1 lg:my-0 lg:ml-2">
          <div className="lg:mx-2 ">วันที่ปัจจุบัน</div>
          <input
            value={query.overDueDate}
            onChange={onField}
            name="overDueDate"
            type="date"
            className="p-2 py-1 border rounded shadow-sm mr-2"
          />
        </div> */}
        <div className="">
          ค้นหาโดยใช้&nbsp;
          <label class="inline-flex items-center lg:ml-2">
            <input
              onChange={(e) => setSearchBy("request_id")}
              type="radio"
              class="form-radio"
              name="search"
              defaultChecked={true}
              checked={searchBy === "request_id"}
            />
            <span class="ml-2">Job. No.</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("name")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "name"}
            />
            <span class="ml-2">ชื่อ</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("requestamount")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "requestamount"}
            />
            <span class="ml-2">วงเงินที่ได้</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("adminName")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "adminName"}
            />
            <span class="ml-2">ชื่อแอดมิน</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={(e) => setSearchBy("phone_number")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "phone_number"}
            />
            <span class="ml-2">เบอร์โทร</span>
          </label>
          <label class="inline-flex items-center ml-2">
            <input
              onChange={() => setSearchBy("citizenid")}
              type="radio"
              class="form-radio"
              name="search"
              checked={searchBy === "citizenid"}
            />
            <span class="ml-2">บัตรประชาชน</span>
          </label>
        </div>

        {/* fortest  */}
        {/* <button
          onClick={onClickGetLoan}
          className={classNames(
            "ml-2 border   duration-300 hover:text-whiteborder-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white"
          )}
        >
          Gen Loan
        </button> */}
      </div>

      <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div className="ml-2">
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onImportExcel}
          />
        </div>{" "}
        <ExcelFile
          filename={`LOAN${format(new Date(), "yyyy-MM-dd")}`}
          element={<button id="loan" hidden></button>}
        >
          <ExcelSheet dataSet={multiDataSet} name="LOAN"></ExcelSheet>
        </ExcelFile>
        <React.Fragment>
          <button
            disabled={!selectedRows.length}
            className={classNames(
              "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
              {
                "bg-gray-300 cursor-not-allowed text-white":
                  !selectedRows.length,
                "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                  selectedRows.length,
              }
            )}
            onClick={onClickExport}
          >
            Export Excel
          </button>
          <ExcelFile
            filename={`LOAN_ALL${format(new Date(), "yyyy-MM-dd")}`}
            element={<button id="loanExportAll" hidden></button>}
          >
            <ExcelSheet dataSet={multiDataSetAll} name="LOAN"></ExcelSheet>
          </ExcelFile>
          <button
            disabled={loadingExportAll || loadingCount}
            className={classNames(
              "ml-2 border p-1 px-2 rounded  duration-300 hover:text-white",
              {
                "bg-gray-300 cursor-not-allowed text-white":
                  loadingExportAll || loadingCount,
                "border-green-500 p-1 px-2 rounded text-white hover:bg-green-600 bg-green-500  hover:text-white":
                  !loadingExportAll || loadingCount,
              }
            )}
            onClick={onClickExportAll}
          >
            {(loadingExportAll || loadingCount) && (
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx={12}
                  cy={12}
                  r={10}
                  stroke="currentColor"
                  strokeWidth={4}
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            Export Excel All ({countObj[currentType]})
          </button>
          {/* {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={loadingAutoMail}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white": loadingAutoMail,
                  "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                    !loadingAutoMail,
                }
              )}
              onClick={autoMail}
            >
              {loadingAutoMail && (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx={12}
                    cy={12}
                    r={10}
                    stroke="currentColor"
                    strokeWidth={4}
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              SendMail ({countAuotMail})
            </button>
          )} */}
          {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={!selectedRows.length || loadingPdf}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length || loadingPdf,
                  "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                    selectedRows.length && !loadingPdf,
                }
              )}
              onClick={generatePdfDocumentInstallment}
            >
              {loadingPdf && (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx={12}
                    cy={12}
                    r={10}
                    stroke="currentColor"
                    strokeWidth={4}
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              Installment PDF
            </button>
          )}
          {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={!selectedRows.length || loadingPdf}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length || loadingPdf,
                  "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                    selectedRows.length && !loadingPdf,
                }
              )}
              onClick={generatePdfDocumentInstallment2}
            >
              {loadingPdf && (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx={12}
                    cy={12}
                    r={10}
                    stroke="currentColor"
                    strokeWidth={4}
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              Installment PDF (v2)
            </button>
          )}
          {/* {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={!selectedRows.length || loadingBuroPdf}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length || loadingBuroPdf,
                  "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                    selectedRows.length && !loadingBuroPdf,
                }
              )}
              onClick={generatePdfBuro}
            >
              {loadingBuroPdf && (
                <svg
                  className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx={12}
                    cy={12}
                    r={10}
                    stroke="currentColor"
                    strokeWidth={4}
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
              )}
              จดหมาย Buro
            </button>
          )} */}
          {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={!selectedRows.length}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                    selectedRows.length,
                }
              )}
              onClick={() => generatePdfDocumentEnvelope(true)}
            >
              ซองจดหมาย
            </button>
          )}
          {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={!selectedRows.length}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-green-500 text-green-500 hover:bg-green-600 hover:text-white":
                    selectedRows.length,
                }
              )}
              onClick={() => generatePdfDocument(true)}
            >
              ออกหนังสือทวงถามครั้งแรก
            </button>
          )}
          {checkRole(user.groups, [
            "SuperAdmin",
            "AnalyzeApprove",
            "Debt",
            "CustomerService",
          ]) && (
            <button
              disabled={!selectedRows.length}
              className={classNames(
                "ml-2 border p-1 px-2 rounded duration-300 hover:text-white",
                {
                  "bg-gray-300 cursor-not-allowed text-white":
                    !selectedRows.length,
                  "border-pink-500 text-pink-500 hover:bg-pink-600 hover:text-white":
                    selectedRows.length,
                }
              )}
              onClick={() => generatePdfDocument()}
            >
              ออกหนังสือทวงถามครั้งที่สอง
            </button>
          )}
        </React.Fragment>
      </div>

      {user.username === "nantanon" &&
        (checkPassword ? (
          <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
            <div>Sync Delete Loan</div>
            <div className="ml-2">
              <CSVReader
                parserOptions={importOptions}
                onFileLoaded={onDeleteImportExcel}
              />
            </div>{" "}
          </div>
        ) : (
          <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
            <div>Sync Delete Loan</div>
            <div className="flex ml-2">
              <div>Password</div>
              <input
                className="border border-gray-400 ml-2"
                type="password"
                value={passwordSyncDelete}
                onChange={(e) => {
                  setPasswordSyncDelete(passwordSyncDelete);
                  if (e.target.value === "1112") {
                    setCheckPassword(true);
                  }
                }}
              />
            </div>{" "}
          </div>
        ))}

      {user.username === "nantanon" && (
        <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
          <div>Sync New AutoDate</div>
          <div className="ml-2">
            <CSVReader
              parserOptions={importOptions}
              onFileLoaded={onSyncAutoDate}
            />
          </div>{" "}
        </div>
      )}

      {user.username === "nantanon" && (
        <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
          <div>Sync Resend</div>
          <div className="ml-2">
            <CSVReader
              parserOptions={importOptions}
              onFileLoaded={onSyncResend}
            />
          </div>{" "}
        </div>
      )}

      <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div className="ml-2 flex flex-row space-x-4">
          <label className="my-auto font-bold text-gray-700">Email</label>
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onImportEmail}
          />
        </div>{" "}
      </div>

      <div className="mx-4 w-full mb-6 lg:flex">
        {/* {!allTime && ( */}
        <React.Fragment>
          <div className="lg:flex items-center ">
            <div className="lg:mr-2 text-sm">Request Period</div>
            <input
              name="min_created"
              value={query.min_created}
              onChange={onField}
              type="date"
              className="p-2 py-1 border rounded shadow-sm"
            />
          </div>
          <div className="lg:flex items-center lg:ml-2">
            <div className="lg:mr-2">To</div>
            <input
              name="max_created"
              value={query.max_created}
              onChange={onField}
              type="date"
              className="p-2 py-1 border rounded shadow-sm mr-2"
            />
          </div>
        </React.Fragment>
        {/* )} */}
        <div className="my-1 lg:my-0 lg:ml-0 w-36">
          <Select
            defaultValue={optionsPackage[0]}
            value={getOption(optionsPackage, query.package)}
            options={optionsPackage}
            onChange={onSelect("package")}
          />
        </div>
        <div className="my-1 lg:my-0 lg:ml-1 w-36">
          <Select
            defaultValue={optionsStatus[0]}
            value={getOption(optionsStatus, query.status)}
            options={optionsStatus}
            onChange={onSelect("status")}
          />
        </div>
        <div className="my-1 lg:my-0 lg:ml-1 w-36">
          <Select
            defaultValue={optionsEmail[0]}
            value={getOption(optionsEmail, query.letter)}
            options={optionsEmail}
            onChange={onSelect("letter")}
          />
        </div>
        <button
          className="ml-2 border border-blue-500 p-1 px-2 rounded text-blue-500 hover:bg-blue-600 duration-300 hover:text-white"
          onClick={onSubmitFilter}
        >
          Submit
        </button>
        <button
          className="ml-2 p-1 px-2 border border-red-500  rounded text-red-500 hover:bg-red-200 duration-300 hover:text-white"
          onClick={onClickResetFilter}
        >
          Clear
        </button>
        <svg
          onClick={refresh}
          xmlns="http://www.w3.org/2000/svg"
          className="h-9 w-9 rounded border border-gray-500 hover:bg-gray-200 text-gray-700 ml-2 p-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
      </div>
      {!datas?.length ? (
        pageType === "NEXT" ? (
          <ContainerContent>
            <div className="text-gray-700 font-bold text-xl w-full text-center mt-20">
              สิ้นสุดรายการ
            </div>
            <div className="w-full mt-2 flex items-center">
              {" "}
              <button
                className="bg-blue-500 text-xl p-4  mx-auto text-white mt-2 "
                onClick={onClickPrevPage}
              >
                ย้อนกลับ
              </button>
            </div>
          </ContainerContent>
        ) : (
          <ContainerContent>
            <DataEmpty />
          </ContainerContent>
        )
      ) : (
        <React.Fragment>
          <div className="flex w-full p-4 pt-0">
            <div className="my-auto w-full flex">
              {loadingCount ? (
                <div className="w-12 mr-2">
                  <Skeleton />
                </div>
              ) : (
                countObj[currentType]
              )}{" "}
              Records{" "}
            </div>
            <div className=" flex justify-between gap-4 ">
              <nav
                className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                aria-label="Pagination"
              >
                <PrevPage
                  canPreviousPage={pageIndex !== 0}
                  onClick={onClickPrevPage}
                />
                <NumberPage number={pageIndex} pageIndex={pageIndex} />
                <NextPage onClick={onClickNextPage} canNextPage={true} />
              </nav>
              <div className="w-24 flex">
                <SelectRows
                  pageSize={pageSize}
                  onChange={onChangeLimit}
                  options={optionsLimit}
                />
              </div>
            </div>
          </div>
          <LoanTable
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            // overdueDateMax={query.max}
            overDueDate={query.overDueDate}
            data={datas}
            getData={getData}
            query={query}
          />
        </React.Fragment>
      )}
    </ContainerContent>
  );
}

export default LoanMain;
